import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import Swal from "sweetalert2";
import { Subject, Observable, forkJoin } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { NgbModal, NgbNav } from "@ng-bootstrap/ng-bootstrap";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { Utils } from "../../../../shared/utils/Utils";
import { Pesv, PesvService } from "../../../../shared/services/pesv.service";
import { PropietarioService } from "../../../../shared/services/propietarios.service";
import { Propietario } from "../../../../shared/model/propietario";
import { AuthService } from "../../../../shared/services/auth.service";
import { HttpEventType } from "@angular/common/http";
import { DigitalesService } from "../../../../shared/services/digitales.service";
import { DigitalesPesv, DigitalesPesvService } from "../../../../shared/services/digitales-pesv.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import {
  FuncionComiteService,
  FuncionComiteAttributes,
} from "../../../../shared/services/funcionComite.service";
import {
  ComiteIntegrante,
  ComiteRegistro,
  ComiteResponse,
  ComiteService,
} from "../../../../shared/services/comite.service";
import {
  NumeroComiteService,
  NumeroComiteResponse,
} from "../../../../shared/services/numeroComite.service";
import { ComiteMotivoService } from "../../../../shared/services/comiteMotivo.service";
import { ComiteActaService } from "../../../../shared/services/comiteActa.service";
import {
  ComiteCompromisosActaService,
  ComiteCompromisosActaPayload,
} from "../../../../shared/services/comiteCompromisosActa.service";
import { ComiteTipoActaService } from "../../../../shared/services/comiteTipoActa.service";
import { FormatosService } from "../../../../shared/services/formatos.service";
import {
  FuncionIntegranteDetalleService,
  FuncionIntegranteDetalle,
} from "../../../../shared/services/funcionIntegranteDetalle.service";
import { FuncionHistorialComiteService } from "../../../../shared/services/funcion-historial-comite.service";
import { environment } from "../../../../../environments/environment";
import { ImplementacionService } from "../../../../shared/services/implementacion.service";
import { VersionesDocumentoService } from "../../../../shared/services/versiones-documento.service";
import { TipoDocumentoService } from "../../../../shared/services/tipodocumento.service";
import { InvitadoComite, InvitadosComiteService } from "../../../../shared/services/invitados-comite.service";
import { Console } from "node:console";
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { GoogleStoragePreviewService } from "../../../../shared/services/google-storage-preview.service";

function normalize(str: any) {
  return str
    ? str
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
    : "";
}

interface ArchivoPesvCard {
  id: number;
  nombre: string;
  prefijo: string;
  file: File | null;
  formatos?: string[];
  formatosLabel?: string;
}

@Component({
  selector: "app-listado-pesv",
  templateUrl: "./listado-pesv.component.html",
  styleUrls: ["./listado-pesv.component.scss"],
  providers: [],
})
export class ListadoPesvComponent implements OnInit, OnDestroy {
  readonly PUNTO_COMITE = 2;

  // Datos principales
  pesv: Pesv[] = [];
  filteredTableItems: Pesv[] = [];

  // Comité
  integrantesComite: any[] = [];
  integrantesReunion: any[] = [];
  usuarioLogin: any;
  historialLideres: any[] = [];
  numerosComiteHistorial: any[] = [];
  filteredNumerosComiteHistorial: any[] = [];
  integrantesExpandidosMap: { [numeroComite: number]: any[] } = {};
  actasExpandidasMap: { [numeroComite: number]: any[] } = {};
  actasAgrupadasMap: {
    [numeroComite: number]: {
      numeroActa: string;
      actas: any[];
      integrantes: any[];
    }[];
  } = {};
  actaGrupoExpandido: {
    [numeroComite: number]: { [numeroActa: string]: boolean };
  } = {};
  funciones_comite: FuncionComiteAttributes[] = [];
  funciones_mostrar: FuncionComiteAttributes[] = [];
  comite_mostrar: ComiteResponse[] = [];
  funcionesIntegranteDetalle: FuncionIntegranteDetalle[] = [];
  opcionesNFuncion: { label: string; value: number }[] = [];
  opcionesNDetalle: { label: string; value: number }[] = [];
  opcionesNDetalleVista: { label: string; value: number }[] = [];
  nFuncionVistaSeleccionada: number | null = null;
  nDetalleVistaSeleccionado: number | null = null;
  // Selección rápida de integrante para asignar funciones (panel inferior)
  selectedIntegrante: any | null = null;
  selectedIntegranteId: number | null = null;

  // Funciones seleccionadas temporalmente para el integrante activo
  funcionesSeleccionadasParaIntegrante: Array<{ n_funcion: number; n_detalle?: number | null; label?: string }> = [];
  cargandoFuncionesIntegranteDetalle = false;
  @ViewChild("modalFuncionDetalle") modalFuncionDetalle:
    | TemplateRef<any>
    | undefined;
  @ViewChild('nav') nav!: NgbNav;  
  formFuncionDetalle!: FormGroup;
  modalFuncionDetalleRef: any;
  mostrarSelectsFuncionDetalle = true;
  numeroComite: number | null = null;
  comiteContinuado = false;
  currentWizardStep: number = 1; // Para controlar el wizard
  cargandoIntegrantes: { [numeroComite: number]: boolean } = {};
  cargandoActas: { [numeroComite: number]: boolean } = {};
  actasExpandidas: { [numeroComite: number]: boolean } = {};
  documentosComiteMap: { [numeroComite: number]: any[] } = {};
  cargandoDocumentosComite: { [numeroComite: number]: boolean } = {};
  indicadorDocumentoComiteMap: { [numeroComite: number]: number } = {};
  private ultimoClickDescargaComite = 0;
  private documentosComitePrecargados = new Set<number>();

  // Control de cancelación de descargas
  private descargaComiteCancel$ = new Subject<void>();

  // Formularios y UI
  formPesv!: FormGroup;
  formEditarIntegrante!: FormGroup;
  formInactivarIntegrante!: FormGroup;
  formActivarIntegrante!: FormGroup;
  formAgregarIntegrante!: FormGroup;
  propietario: Propietario | null = null;
  propietarioParaAgregar: Propietario | null = null;
  personaYaAgregadaEnComite = false;
  buscandoPersonaParaAgregar = false;
  mensajeBusquedaPersonaAgregar = "";
  tipoMensajeBusquedaPersonaAgregar: "warning" | "danger" | "info" = "info";
  pdfFileSelected: File | null = null; // Archivo PDF seleccionado
  archivoSoporteComite: File | null = null; // Archivo soporte del comité
  archivoDigitalComite: ArchivoPesvCard = {
    id: 0,
    nombre: "Documento soporte del comite",
    prefijo: "COM",
    file: null,
    formatos: ["pdf"],
    formatosLabel: "pdf",
  };
  empresaNit: string | null = null;
  empresaNombre: string = "";
  configuracionDigitalComite: DigitalesPesv | null = null;
  formatosPermitidosComite: string[] = ["pdf"];
  propietarioEncontrado!:any; 
  // 🔄 Consolidar flags de carga
  cargandoState = {
    general: false,
    historial: false,
    guardar: false,
    funciones: false,
    inactivar: false,
    activar: false,
  };
  comiteMotivo2: any;
  tipoActa: any;
  expandedRowId: number | null = null;
  modoEdicion = false;
  actaIdEnEdicion: number | null = null;
  idActaEditar: number | null = null;
  listaFunciones:[]=[];
toggleRow(acta: any): void {
  this.expandedRowId =
    this.expandedRowId === acta.id
      ? null
      : acta.id;
}

  // Getter para compatibilidad con el código existente
  get cargando(): boolean {
    return this.cargandoState.general;
  }
  set cargando(value: boolean) {
    this.cargandoState.general = value;
  }
  get cargandoHistorial(): boolean {
    return this.cargandoState.historial;
  }
  set cargandoHistorial(value: boolean) {
    this.cargandoState.historial = value;
  }
  get cargandoGuardar(): boolean {
    return this.cargandoState.guardar;
  }
  set cargandoGuardar(value: boolean) {
    this.cargandoState.guardar = value;
  }
  get cargandoFunciones(): boolean {
    return this.cargandoState.funciones;
  }
  set cargandoFunciones(value: boolean) {
    this.cargandoState.funciones = value;
  }
  get cargandoInactivar(): boolean {
    return this.cargandoState.inactivar;
  }
  set cargandoInactivar(value: boolean) {
    this.cargandoState.inactivar = value;
  }
  get cargandoActivar(): boolean {
    return this.cargandoState.activar;
  }
  set cargandoActivar(value: boolean) {
    this.cargandoState.activar = value;
  }

  // Modal
  @ViewChild("modalEditarIntegrante") modalEditarIntegrante:
    | TemplateRef<any>
    | undefined;
  modalEditarIntegranteRef: any;
  integranteEnEdicion: any = null;
  numeroComiteEnEdicion: number | null = null;
  @ViewChild("modalInactivarIntegrante") modalInactivarIntegrante:
    | TemplateRef<any>
    | undefined;
  modalInactivarIntegranteRef: any;
  integranteInactivar: any = null;
  numeroComiteInactivar: number | null = null;
  @ViewChild("modalActivarIntegrante") modalActivarIntegrante:
    | TemplateRef<any>
    | undefined;
  modalActivarIntegranteRef: any;
  integranteActivar: any = null;
  numeroComiteActivar: number | null = null;
  @ViewChild("modalInactivarComite") modalInactivarComite:
    | TemplateRef<any>
    | undefined;
  modalInactivarComiteRef: any;
  numeroComiteAInactivar: number | null = null;
  @ViewChild("modalAgregarIntegrante") modalAgregarIntegrante:
    | TemplateRef<any>
    | undefined;
  modalAgregarIntegranteRef: any;
  numeroComiteParaAgregar: number | null = null;
  @ViewChild("modalIntegrantesComite") modalIntegrantesComite:
    | TemplateRef<any>
    | undefined;
  modalIntegrantesComiteRef: any;
  numeroComiteIntegrantesModal: number | null = null;
  estadoComiteIntegrantesModal: number | null = null;
  integrantesModalLista: any[] = [];
  integrantesModalListaFiltrada: any[] = [];
  searchTextIntegrantesModal = "";
  pageIntegrantesModal = 1;
  pageSizeIntegrantesModal = 5;
  cargandoIntegrantesModal = false;
  @ViewChild("modalActasComite") modalActasComite:
    | TemplateRef<any>
    | undefined;
  modalActasComiteRef: any;
  @ViewChild("modalDetalleActaComite") modalDetalleActaComite:
    | TemplateRef<any>
    | undefined;
  modalDetalleActaComiteRef: any;
  @ViewChild("modalVistaPreviaDocumentoComite") modalVistaPreviaDocumentoComite:
    | TemplateRef<any>
    | undefined;
  modalVistaPreviaDocumentoComiteRef: any;
  @ViewChild("modalBuscarInvitado") modalBuscarInvitado:
    | TemplateRef<any>
    | undefined;
  modalBuscarInvitadoRef: any;
  @ViewChild("modalCrearInvitado") modalCrearInvitado:
    | TemplateRef<any>
    | undefined;
  modalCrearInvitadoRef: any;
  cedulaBuscaInvitado: string = "";
  personaBuscadaInvitado: any = null;
  cargandoBuscaInvitado = false;
  errorBuscaInvitado: string = "";
  tiposDocumentoInvitado: any[] = [];
  formCrearInvitado!: FormGroup;
  cargandoCrearInvitado = false;
  numeroComiteActasModal: number | null = null;
  actasModalLista: any[] = [];
  actasModalListaFiltrada: any[] = [];
  actasModalExpandido: { [numeroActa: string]: boolean } = {};
  actaDetalleSeleccionada: any = null;
  searchTextActasModal = "";
  pageActasModal = 1;
  pageSizeActasModal = 5;
  cargandoActasModal = false;
  documentoComitePreviewUrl: SafeResourceUrl | null = null;
  documentoComitePreviewBlobUrl: string | null = null;
  documentoComitePreviewNombre = "";
  descargandoDocumentoComiteId: number | null = null;

  // Búsqueda y filtrado
  searchText = "";
  searchTextHistorialComite = "";
  pageSize1 = 5;
  page1 = 1;
  tabActivo = 1;
  filtroComite: "todos" | "activos" | "inactivos" = "todos";

  // Fechas
  fechaMaxDesignacion: string = "";
  fechaMinVigenciaDesde: string = "";
  fechaMinVencimiento: string = "";
  fechaMinVigenciaHasta: string = ""; // Vigencia Hasta: mínimo 3 meses desde vigenciaDesde

  // Privados
  private cedulaSearch$ = new Subject<string>();
  private destroy$ = new Subject<void>();
  private timeoutBusquedaPersonaParaAgregar: any = null;
  comiteMotivo: any;
  integrantesActivos: any[] = []; // 📝 Cambiar nombre de comiteActivos a integrantesActivos
  personaInvitadoSeleccionada: any = null; // Persona invitada seleccionada desde búsqueda
    private maestroImplementacion: any = null;
    private maestroActaReunion: any = null;
    versionesImplementacion: any[] = [];
    versionesActaReunion: any[] = [];
  documentosCargadosComite = false;

  constructor(
    private propietariosService: PropietarioService,
    private funcionComiteService: FuncionComiteService,
    private comiteService: ComiteService,
    private numeroComiteService: NumeroComiteService,
    private comiteMotivoService: ComiteMotivoService,
    private comiteActaService: ComiteActaService,
    private comiteCompromisosActaService: ComiteCompromisosActaService,
    private comiteTipoActaService: ComiteTipoActaService,
    private funcionIntegranteDetalleService: FuncionIntegranteDetalleService,
    private funcionHistorialComiteService: FuncionHistorialComiteService,
    private authService: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private administracionService: AdministracionService,
    private digitalesService: DigitalesService,
    private digitalesPesvService: DigitalesPesvService,
    private implementacionService: ImplementacionService,
    private versionesDocumentoService: VersionesDocumentoService,
    private formatosService: FormatosService,
    private tipoDocumentoService: TipoDocumentoService,
    private invitadosComiteService: InvitadosComiteService,
    private gpcGoogle: gpcGoogleService,
    private googleStoragePreview: GoogleStoragePreviewService,
  ) {}

  ngOnInit(): void {

    this.modoEdicion = false;

    this.formPesv = this.fb.group({
      // TAB 1: Designar Comité
      numeroComite: ["", Validators.required],
      cedula: ["", Validators.required],
      nombre:["",Validators.required],
      funcion: ["", Validators.required],
      // Fechas del número de comité
      fechainicio: ["", Validators.required],
      fechaVigencia: ["", Validators.required],
      // TAB 3: Acta de Reunión
      integranteSeleccionado: [null],
      numeroActa: [""],
      fechaReunion: ["", Validators.required],
      horaInicio: ["", Validators.required],
      horaFinalizacion: ["", Validators.required],
      lugarReunion: ["", Validators.required],
      tipoReunion: [null, Validators.required],
      nombreComite: ["Comité PESV"],
      //empresa: [{ value: "", disabled: true }, Validators.required],
      vigenciaDesde: ["", [Validators.required, this.fechaNoPasadaValidator]],
      vigenciaHasta: ["", Validators.required],
      temasTratados: ["", [Validators.required, Validators.minLength(10)]],
      compromisoActa: [""],
    });

    this.formFuncionDetalle = this.fb.group({
      nFuncionDetalle: [null, Validators.required],
      descripcionDetalle: ["", [Validators.required, Validators.minLength(3)]],
    });

    this.formEditarIntegrante = this.fb.group({
      cedula: [{ value: "", disabled: true }],
      nombre: [{ value: "", disabled: true }],
      cargoLaboral: [{ value: "", disabled: true }],
      funcion: ["", Validators.required],
      estado: ["", Validators.required],
    });

    this.formInactivarIntegrante = this.fb.group({
      motivo: [null, Validators.required],
      observaciones: ["", [Validators.required, Validators.minLength(3)]],
    });

    this.formActivarIntegrante = this.fb.group({
      motivo: [null, Validators.required],
      observaciones: ["", [Validators.required, Validators.minLength(3)]],
    });

    this.formAgregarIntegrante = this.fb.group({
      cedula: ["", Validators.required],
      funcion: ["", Validators.required],
    });

    this.formCrearInvitado = this.fb.group({
      tipo_documento: [null, Validators.required],
      cc: ["", Validators.required],
      primer_nombre: ["", [Validators.required, Validators.minLength(2)]],
      segundo_nombre: [""],
      primer_apellido: ["", [Validators.required, Validators.minLength(2)]],
      segundo_apellido: [""],
      telefono: ["", Validators.required],
    });

    this.usuarioLogin = this.authService.getCurrentUserValue();
    this.inicializarFechas();
    this.cargarNitEmpresa();
    this.cargarFuncionesIntegranteDetalle();
    this.cargarTiposDocumentoInvitado();

    forkJoin([
      this.comiteMotivoService.getAll(),
      this.comiteMotivoService.getmotivos2(),
      this.funcionComiteService.getAll(),
      this.comiteService.getAllActivos(),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ([motivos, motivos2, funciones, integrantes]) => {
          // 🔧 Extraer el array 'data' si la respuesta viene envuelta
          const motivosArray = Array.isArray(motivos)
            ? motivos
            : (motivos as any)?.data || [];
          const motivos2Array = Array.isArray(motivos2)
            ? motivos2
            : (motivos2 as any)?.data || [];
          const funcionesArray = Array.isArray(funciones)
            ? funciones
            : (funciones as any)?.data || [];
          const integrantesArray = Array.isArray(integrantes)
            ? integrantes
            : (integrantes as any)?.data || [];

          this.comiteMotivo = motivosArray;
          this.comiteMotivo2 = motivos2Array;
          this.funciones_comite = funcionesArray;
          this.funciones_mostrar = [...funcionesArray];
          this.integrantesActivos = integrantesArray;
          this.cargandoFunciones = false;
        },
        error: (err: any) => {
          this.comiteMotivo = [];
          this.funciones_comite = [];
          this.funciones_mostrar = [];
          this.integrantesActivos = [];
          this.cargandoFunciones = false;
        },
      });

    // 🔧 Cargar tipo acta por separado (evitar que bloquee el forkJoin)
    this.cargartipoActa();

    // Cargar historial y número de comité
    this.cargarHistorial();
    this.obtenerProximoNumeroComite();

    // Configurar búsqueda por cédula
    this.cedulaSearch$
      .pipe(debounceTime(600), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((cedula: string) => this.buscarPersonaPorCedula(cedula));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timeoutBusquedaPersonaParaAgregar) {
      clearTimeout(this.timeoutBusquedaPersonaParaAgregar);
      this.timeoutBusquedaPersonaParaAgregar = null;
    }
  }

  private cargarNitEmpresa(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (res: any) => {
        const lista = Array.isArray(res)
          ? res
          : Array.isArray(res?.administraciones)
            ? res.administraciones
            : [];
        this.empresaNit = lista?.[0]?.nit ? String(lista[0].nit) : null;
        this.empresaNombre = lista?.[0]?.empresa ? String(lista[0].empresa) : "";
        this.formPesv.patchValue({
          empresa: this.empresaNombre,
        });
      },
      error: (err: any) => {
        console.error("Error al cargar NIT de la empresa:", err);
      },
    });
  }



  private cargarFuncionesIntegranteDetalle(): void {
    this.cargandoFuncionesIntegranteDetalle = true;

    this.funcionIntegranteDetalleService.getActivos().subscribe({
      next: (data: FuncionIntegranteDetalle[]) => {
        const lista = Array.isArray(data) ? data : [];
        this.funcionesIntegranteDetalle = lista;

        const mapNFuncion = new Map<number, string>();
        const mapNDetalle = new Map<number, string>();

        lista.forEach((item) => {
          if (item.n_funcion && !mapNFuncion.has(item.n_funcion)) {
            mapNFuncion.set(
              item.n_funcion,
              item.funcionIntegrante?.descripcion || `Función ${item.n_funcion}`,
            );
          }

          const detalles = Array.isArray((item as any)?.detalles) ? (item as any).detalles : [];
          detalles.forEach((detalle: any) => {
            const nDetalle = Number(detalle?.n_detalle);
            const descripcionDetalle = detalle?.funcionesDetIntegrantes?.descripcion || detalle?.descripcion || `Detalle ${nDetalle}`;

            if (nDetalle && !mapNDetalle.has(nDetalle)) {
              mapNDetalle.set(nDetalle, descripcionDetalle);
            }
          });
        });

        this.opcionesNFuncion = Array.from(mapNFuncion.entries())
          .sort((a, b) => a[0] - b[0])
          .map(([value, label]) => ({ label, value }));

        this.opcionesNDetalle = Array.from(mapNDetalle.entries())
          .sort((a, b) => a[0] - b[0])
          .map(([value, label]) => ({ label, value }));

        this.opcionesNDetalleVista = [];
        this.sincronizarDetallesEnIntegrantes();

        this.cargandoFuncionesIntegranteDetalle = false;
      },
      error: () => {
        this.funcionesIntegranteDetalle = [];
        this.opcionesNFuncion = [];
        this.opcionesNDetalle = [];
        this.opcionesNDetalleVista = [];
        this.cargandoFuncionesIntegranteDetalle = false;
      },
    });
  }

  private cargarTiposDocumentoInvitado(): void {
    this.tipoDocumentoService.getTiposDocumento().subscribe({
      next: (data: any[]) => {
        this.tiposDocumentoInvitado = Array.isArray(data)
          ? data
              .map((item: any) => ({
                id: Number(item?.id || item?.idTipodocumento || 0),
                descripcion: String(item?.descripcion || item?.nombre || '').trim(),
              }))
              .filter((item: any) => !!item.id && !!item.descripcion)
          : [];
      },
      error: () => {
        this.tiposDocumentoInvitado = [];
      },
    });
  }

  private sincronizarDetallesEnIntegrantes(): void {
    (this.integrantesComite || []).forEach((integrante) => {
      if (!integrante || !integrante.n_funcion) {
        return;
      }

      const opcionesDetalle = this.obtenerDetallesParaFuncion(integrante.n_funcion);
      integrante._opcionesDetalle = opcionesDetalle;

      const detallesSeleccionados = Array.isArray(integrante.detallesSeleccionados)
        ? integrante.detallesSeleccionados.map((valor: any) => Number(valor)).filter((valor: number) => !Number.isNaN(valor) && valor > 0)
        : [];

      if (detallesSeleccionados.length > 0) {
        const etiquetas = detallesSeleccionados
          .map((valor: number) => opcionesDetalle.find((item) => Number(item.value) === valor)?.label || `Detalle ${valor}`)
          .filter((valor: string) => !!valor);

        integrante.detalleDescripcion = etiquetas.join("; ");
        integrante.funciones_det = etiquetas.length ? this.formatFuncionesDetFromArray(etiquetas) : null;
      }
    });
  }

  private obtenerMensajeBackend(response: any, fallback: string): string {
    if (typeof response === "string") {
      return response;
    }

    return (
      response?.message ||
      response?.error ||
      response?.error?.message ||
      response?.msg ||
      response?.detalle ||
      response?.description ||
      fallback
    );
  }

  onFuncionVistaChange(nFuncion: number | string | { value?: number | string; n_funcion?: number | string } | null): void {
    const valorNormalizado =
      typeof nFuncion === 'object' && nFuncion !== null
        ? (nFuncion.value ?? nFuncion.n_funcion)
        : nFuncion;

    this.nFuncionVistaSeleccionada = valorNormalizado !== null && valorNormalizado !== undefined && valorNormalizado !== ''
      ? Number(valorNormalizado)
      : null;
    this.nDetalleVistaSeleccionado = null;

    if (!this.nFuncionVistaSeleccionada) {
      this.opcionesNDetalleVista = [];
      return;
    }

    const coincidencias = this.funcionesIntegranteDetalle
      .filter((item) => Number(item.n_funcion) === this.nFuncionVistaSeleccionada)
      .flatMap((item) => Array.isArray((item as any)?.detalles) ? (item as any).detalles : [])
      .map((detalle: any) => ({
        value: Number(detalle?.n_detalle),
        label: detalle?.funcionesDetIntegrantes?.descripcion || detalle?.descripcion || `Detalle ${detalle?.n_detalle}`,
      }))
      .filter((item, index, array) => item.value && array.findIndex((otro) => otro.value === item.value) === index)
      .sort((a, b) => a.value - b.value);

    this.opcionesNDetalleVista = coincidencias;
  }

  // Devuelve los detalles (n_detalle) disponibles para una función dada (por id de función)
  obtenerDetallesParaFuncion(nFuncionId: number | null | undefined): { label: string; value: number }[] {
    const idNumero = Number(nFuncionId);
    if (!idNumero) return [];

    const coincidencias = this.funcionesIntegranteDetalle
      .filter((item) => Number(item.n_funcion) === idNumero)
      .flatMap((item) => Array.isArray((item as any)?.detalles) ? (item as any).detalles : [])
      .map((detalle: any) => ({
        value: Number(detalle?.n_detalle),
        label: detalle?.funcionesDetIntegrantes?.descripcion || detalle?.descripcion || `Detalle ${detalle?.n_detalle}`,
      }))
      .filter((item, index, array) => item.value && array.findIndex((otro) => otro.value === item.value) === index)
      .sort((a, b) => a.value - b.value);

    if (coincidencias.length > 0) {
      return coincidencias;
    }

    const funcionDescripcion = this.obtenerDescripcionFuncion(idNumero);
    return funcionDescripcion && funcionDescripcion !== "Sin especificar"
      ? [{ value: idNumero, label: funcionDescripcion }]
      : [];
  }

  onDetalleFilaChange(integrante: any, nDetalle: number | string | Array<number | string> | null): void {
    const valoresSeleccionados = Array.isArray(nDetalle)
      ? nDetalle
          .map((valor) => Number(valor))
          .filter((valor) => !Number.isNaN(valor) && valor > 0)
      : nDetalle !== null && nDetalle !== undefined && nDetalle !== ""
        ? [Number(nDetalle)]
        : [];

    integrante.n_detalle = valoresSeleccionados.length > 0 ? valoresSeleccionados[0] : null;
    integrante.detallesSeleccionados = valoresSeleccionados;

    if (valoresSeleccionados.length === 0) {
      integrante.detalleDescripcion = "";
      return;
    }

    const opciones = this.obtenerDetallesParaFuncion(integrante.n_funcion);
    const etiquetas = valoresSeleccionados
      .map((valor) => opciones.find((item) => Number(item.value) === valor)?.label || `Detalle ${valor}`)
      .filter((valor) => !!valor);

    integrante.detalleDescripcion = etiquetas.join("; ");
    integrante.funciones_det = this.formatFuncionesDetFromArray(etiquetas);
  }

  obtenerEtiquetaDetalleIntegrante(integrante: any): string {
    if (Array.isArray(integrante?.detallesSeleccionados) && integrante.detallesSeleccionados.length > 0) {
      return this.etiquetasParaMostrar(integrante).join("; ");
    }

    if (integrante?.detalleDescripcion) {
      return integrante.detalleDescripcion;
    }

    if (integrante?.n_detalle) {
      const opciones = this.obtenerDetallesParaFuncion(integrante.n_funcion);
      const detalle = opciones.find((item) => Number(item.value) === Number(integrante.n_detalle));
      return detalle?.label || `Detalle ${integrante.n_detalle}`;
    }

    return "";
  }
  etiquetasParaMostrar(integrante: any): string[] {
    const seleccionados = Array.isArray(integrante?.detallesSeleccionados)
      ? integrante.detallesSeleccionados
      : this.ensureArray(integrante?.detallesSeleccionados);

    if (!seleccionados.length) {
      return [];
    }

    const opciones = this.obtenerDetallesParaFuncion(integrante?.n_funcion);
    return seleccionados
      .map((valor: any) => {
        const valorNumero = Number(valor);
        return opciones.find((item) => Number(item.value) === valorNumero)?.label || `Detalle ${valorNumero}`;
      })
      .filter((valor: string) => !!valor);
  }

  // Maneja la selección desde el dropdown de integrantes (panel inferior)
  onSelectIntegranteById(id: number | null): void {
    this.selectedIntegranteId = id;
    if (id == null) {
      this.selectedIntegrante = null;
      this.funcionesSeleccionadasParaIntegrante = [];
      return;
    }
    const integ = this.integrantesComite?.find((x: any) => Number(x.id) === Number(id)) || null;
    this.selectedIntegrante = integ;
    this.funcionesSeleccionadasParaIntegrante = this.selectedIntegrante && this.selectedIntegrante.funciones ? [...this.selectedIntegrante.funciones] : [];
    this.nFuncionVistaSeleccionada = null;
    this.nDetalleVistaSeleccionado = null;
  }

  // Añade la función seleccionada al arreglo temporal
  agregarFuncionAIntegrante(): void {
    if (!this.selectedIntegrante) return;
    if (!this.nFuncionVistaSeleccionada) return;
    const label = this.opcionesNFuncion?.find(f => Number(f.value) === Number(this.nFuncionVistaSeleccionada))?.label || '';
    const exists = this.funcionesSeleccionadasParaIntegrante.find(f => Number(f.n_funcion) === Number(this.nFuncionVistaSeleccionada) && (f.n_detalle == this.nDetalleVistaSeleccionado));
    if (exists) return;
    this.funcionesSeleccionadasParaIntegrante.push({ n_funcion: Number(this.nFuncionVistaSeleccionada), n_detalle: this.nDetalleVistaSeleccionado ? Number(this.nDetalleVistaSeleccionado) : null, label });
  }

  quitarFuncionDeIntegrante(index: number): void {
    if (index >= 0 && index < this.funcionesSeleccionadasParaIntegrante.length) {
      this.funcionesSeleccionadasParaIntegrante.splice(index, 1);
    }
  }

  // Aplica las funciones seleccionadas al integrante actualmente seleccionado (en memoria)
  aplicarFuncionesToIntegrante(): void {
    if (!this.selectedIntegrante) return;
    // Convertir formato temporal a la estructura usada internamente
    const funciones = this.funcionesSeleccionadasParaIntegrante.map(f => {
      return {
        n_funcion: Number(f.n_funcion),
        n_detalle: f.n_detalle ? Number(f.n_detalle) : null,
        descripcion: f.label || ''
      } as any;
    });
    // Asignar localmente; si se desea persistir, el guardado debe incluir esta información en el payload de guardarComite
    this.selectedIntegrante.funcion = funciones.map((fn: any) => fn.descripcion || String(fn.n_funcion));
    this.selectedIntegrante.detallesSeleccionados = funciones.map((fn: any) => fn.n_detalle).filter((d: any) => d != null);
    // Opcional: actualizar en array principal
    const idx = this.integrantesComite.findIndex((x: any) => x === this.selectedIntegrante);
    if (idx >= 0) {
      this.integrantesComite[idx] = this.selectedIntegrante;
    }
  }

  formatearFuncionesIntegrante(funciones: any): string {
    const arr = this.ensureArray(funciones);
    return arr
      .map((f: any) => {
        const num = Number(f);
        if (!Number.isNaN(num) && num > 0) {
          const desc = this.obtenerDescripcionFuncion(num);
          return desc && desc !== 'Sin especificar' ? desc : String(f);
        }
        return String(f);
      })
      .join("; ");
  }

  abrirModalFuncionDetalleParaFila(_integrante: any): void {
    this.abrirModalFuncionDetalle();
  }

  private construirOpcionesNumericas(valores: Array<number | string | null | undefined>): { label: string; value: number }[] {
    const unicos = new Set<number>();

    valores.forEach((valor) => {
      const numero = Number(valor);
      if (!Number.isNaN(numero) && numero > 0) {
        unicos.add(numero);
      }
    });

    return Array.from(unicos)
      .sort((a, b) => a - b)
      .map((value) => ({ label: String(value), value }));
  }

  abrirModalFuncionDetalle(): void {
    this.formFuncionDetalle.reset({ nFuncionDetalle: null, descripcionDetalle: "" });
    this.modalFuncionDetalleRef = this.modalService.open(this.modalFuncionDetalle, {
      size: "xl",
      centered: true,
      backdrop: "static",
    });
  }

  guardarFuncionIntegranteDetalle(modalRef: any): void {
    const nFuncion = Number(this.formFuncionDetalle.get("nFuncionDetalle")?.value);
    const descripcionDetalle = String(this.formFuncionDetalle.get("descripcionDetalle")?.value || "").trim();

    if (!nFuncion) {
      Swal.fire(
        "Advertencia",
        "Seleccione una función integrante antes de guardar.",
        "warning",
      );
      return;
    }

    if (!descripcionDetalle) {
      Swal.fire(
        "Advertencia",
        "Escriba el detalle integrante antes de agregar.",
        "warning",
      );
      return;
    }

    const yaExisteRelacion = this.funcionesIntegranteDetalle.some((item) =>
      Number(item.n_funcion) === nFuncion &&
      Array.isArray((item as any)?.detalles) &&
      (item as any).detalles.some(
        (detalle: any) => normalize(detalle?.funcionesDetIntegrantes?.descripcion || detalle?.descripcion) === normalize(descripcionDetalle),
      ),
    );

    if (yaExisteRelacion) {
      Swal.fire(
        "Advertencia",
        "La relación función/detalle ya existe en el catálogo.",
        "warning",
      );
      return;
    }

    const payload: FuncionIntegranteDetalle = {
      n_funcion: nFuncion,
      descripcion_detalle: descripcionDetalle,
      estado: 1,
    };

    this.cargando = true;
    this.funcionIntegranteDetalleService.create(payload as any).subscribe({
      next: () => {
        this.cargando = false;
        this.cargarFuncionesIntegranteDetalle();
        this.sincronizarDetallesEnIntegrantes();
        this.formFuncionDetalle.reset({ nFuncionDetalle: null, descripcionDetalle: "" });
        modalRef?.close();
        Swal.fire(
          "Éxito",
          "La relación fue agregada correctamente.",
          "success",
        );
      },
      error: () => {
        this.cargando = false;
      },
    });
  }

  

  private esRegistroActivo(estado: any): boolean {
    if (typeof estado === "boolean") {
      return estado;
    }
    if (typeof estado === "number") {
      return estado === 1;
    }
    if (typeof estado === "string") {
      return ["1", "true", "activo", "active", "si", "sí"].includes(
        estado.trim().toLowerCase(),
      );
    }
    return false;
  }

  private obtenerExtensionesDesdeFormatos(formatos: string | undefined): string[] {
    if (!formatos) {
      return [];
    }

    const tokens = formatos
      .toLowerCase()
      .split(/[,/\s]+/)
      .map((t) => t.trim())
      .filter((t) => t.length > 0);

    const extensiones: string[] = [];
    tokens.forEach((token) => {
      switch (token) {
        case "word":
          extensiones.push("doc", "docx");
          break;
        case "pdf":
          extensiones.push("pdf");
          break;
        case "excel":
          extensiones.push("xls", "xlsx");
          break;
        default:
          extensiones.push(token.replace(".", ""));
          break;
      }
    });

    return Array.from(new Set(extensiones));
  }

  onFileChangeComite(event: any): void {
    const file: File = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    const extension = file.name.split(".").pop()?.toLowerCase() || "";
    if (!this.formatosPermitidosComite.includes(extension)) {
      const permitidos = this.formatosPermitidosComite.map((f) => `.${f}`).join(", ");
      Swal.fire("Formato inválido", `Solo se aceptan: ${permitidos}`, "warning");
      event.target.value = "";
      this.archivoSoporteComite = null;
      return;
    }

    this.archivoSoporteComite = file;
    this.archivoDigitalComite.file = file;
    this.mostrarSelectsFuncionDetalle = false; // Ocultar selects cuando se carga documento
    event.target.value = "";
  }

  onDragOverComite(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.add("drag-over");
  }

  onDragLeaveComite(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");
  }

  onDropComite(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");

    const file = event.dataTransfer?.files?.[0];
    if (!file) {
      return;
    }

    const extension = file.name.split(".").pop()?.toLowerCase() || "";
    if (!this.formatosPermitidosComite.includes(extension)) {
      const permitidos = this.formatosPermitidosComite.map((f) => `.${f}`).join(", ");
      Swal.fire("Formato inválido", `Solo se aceptan: ${permitidos}`, "warning");
      return;
    }

    this.archivoSoporteComite = file;
    this.archivoDigitalComite.file = file;
    this.mostrarSelectsFuncionDetalle = false;
    event.dataTransfer?.clearData();
  }

  removeArchivoComite(): void {
    this.archivoSoporteComite = null;
    this.archivoDigitalComite.file = null;
    this.mostrarSelectsFuncionDetalle = true; // Mostrar selects nuevamente al remover documento
  }

  private normalizarSegmentoComite(valor: string): string {
    return (valor || "")
      .toString()
      .replace(/[^a-zA-Z0-9_-]/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_|_$/g, "");
  }

  private normalizarClaveVariableComite(valor: string): string {
    return normalize(valor || "").replace(/[^a-z0-9]+/g, "_");
  }

  private construirCodigoDocumentoComite(numeroComite?: number): string {
    const consecutivo = numeroComite ?? this.numeroComite ?? undefined;
    return consecutivo ? `COMITE_${consecutivo}` : "COMITE";
  }

  private construirContextoNombreComite(numeroComite?: number): { [key: string]: string } {
    const consecutivo = numeroComite ?? this.numeroComite ?? undefined;
    const punto = Number(this.configuracionDigitalComite?.id_relacion) || this.PUNTO_COMITE;
    const tipoDocumento = (
      this.configuracionDigitalComite?.tipo_documentos || this.archivoDigitalComite.nombre || "COMITE_PESV"
    ).toString();
    const sigla = (this.configuracionDigitalComite?.siglas || this.archivoDigitalComite.prefijo || "COM").toString();
    const codigo = this.construirCodigoDocumentoComite(consecutivo);

    return {
      numero_comite: consecutivo ? String(consecutivo) : "",
      comite: consecutivo ? String(consecutivo) : "",
      codigo,
      punto: String(punto),
      punto_digital: String(punto),
      sigla,
      tipo_documento: tipoDocumento,
      nombre_documento: tipoDocumento,
      nit: this.empresaNit || "",
    };
  }

  private reemplazarVariablesNombreComite(plantilla: string, numeroComite?: number): string {
    if (!plantilla) {
      return "";
    }

    const contexto = this.construirContextoNombreComite(numeroComite);
    const reemplazado = plantilla.replace(
      /\$\{([^}]+)\}|\{([^}]+)\}|\[([^\]]+)\]/g,
      (_match, dolar, llaves, corchetes) => {
        const variable = dolar || llaves || corchetes || "";
        const clave = this.normalizarClaveVariableComite(variable);
        return contexto[clave] || "";
      },
    );

    return this.normalizarSegmentoComite(reemplazado).toUpperCase();
  }

  private construirNombreBaseDocumentoComite(numeroComite?: number): string {
    
    return 'ACTA_COMITE_PESV_' + (numeroComite ?? this.numeroComite ?? 'X');
  }

  private construirNombreArchivoDocumentoComite(file: File, numeroComite?: number): string {
    const extension = file.name.split(".").pop()?.toLowerCase() || "bin";
    const nombreBase = this.construirNombreBaseDocumentoComite(numeroComite);
    return `${nombreBase}.${extension}`;
  }

  private extensionDesdeMimeComite(mimeType: string): string {
    if (!mimeType) return "bin";
    if (mimeType.includes("pdf")) return "pdf";
    if (mimeType.includes("wordprocessingml") || mimeType.includes("msword")) return "docx";
    if (mimeType.includes("spreadsheetml") || mimeType.includes("excel")) return "xlsx";
    if (mimeType.includes("presentationml") || mimeType.includes("powerpoint")) return "pptx";
    if (mimeType.includes("image/")) return mimeType.split("/")[1] || "img";
    return "bin";
  }

  private extensionDesdeConfiguracionComite(): string {
    const formatos = this.archivoDigitalComite.formatos || [];
    for (const formato of formatos) {
      if (formato === "doc" || formato === "docx") return "docx";
      if (formato === "pdf") return "pdf";
      if (formato === "xls" || formato === "xlsx") return "xlsx";
    }
    return "bin";
  }

  private async extensionDesdeFirmaComite(blob: Blob): Promise<string> {
    try {
      const buffer = await blob.slice(0, 8).arrayBuffer();
      const bytes = new Uint8Array(buffer);

      if (
        bytes.length >= 4 &&
        bytes[0] === 0x25 &&
        bytes[1] === 0x50 &&
        bytes[2] === 0x44 &&
        bytes[3] === 0x46
      ) {
        return "pdf";
      }

      if (bytes.length >= 2 && bytes[0] === 0x50 && bytes[1] === 0x4b) {
        const formatos = this.archivoDigitalComite.formatos || [];
        if (formatos.includes("doc") || formatos.includes("docx")) return "docx";
        if (formatos.includes("xls") || formatos.includes("xlsx")) return "xlsx";
        return "docx";
      }
    } catch (e) {
      console.warn("No se pudo detectar firma binaria del archivo de comité:", e);
    }

    return "";
  }

  private extraerExtensionDeNombreComite(nombre: string | undefined): string {
    if (!nombre) return "";
    const limpio = nombre.replace(/\"/g, "").trim();
    const partes = limpio.split(".");
    if (partes.length < 2) return "";
    return (partes.pop() || "").toLowerCase();
  }

  private extraerNombreDeContentDispositionComite(contentDisposition: string | null): string {
    if (!contentDisposition) return "";
    const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
    if (utf8?.[1]) {
      return decodeURIComponent(utf8[1]);
    }
    const normal = /filename=\"?([^\";]+)\"?/i.exec(contentDisposition);
    return normal?.[1] || "";
  }

  private abrirVistaPreviaDocumentoComite(blob: Blob, nombreArchivo?: string, numeroComite?: number): void {
    console.log("abrirVistaPreviaDocumentoComite - blob:", blob, "size:", blob?.size, "nombreArchivo:", nombreArchivo);

    if (!blob || blob.size === 0) {
      console.error("Blob vacío para vista previa");
      Swal.fire("Error", "El documento está vacío", "error");
      return;
    }

    this.cerrarVistaPreviaDocumentoComite();

    const blobUrl = window.URL.createObjectURL(blob);
    console.log("Blob URL creado:", blobUrl);

    this.documentoComitePreviewBlobUrl = blobUrl;
    this.documentoComitePreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    this.documentoComitePreviewNombre = nombreArchivo || this.construirNombreBaseDocumentoComite(numeroComite) || "Documento soporte del comité";

    if (!this.modalVistaPreviaDocumentoComite) {
      console.warn("Template modal no encontrado, abriendo en nueva ventana");
      window.open(blobUrl, "_blank");
      return;
    }

    console.log("Abriendo modal de vista previa");
    this.modalVistaPreviaDocumentoComiteRef = this.modalService.open(this.modalVistaPreviaDocumentoComite, {
      size: "xl",
      centered: true,
      scrollable: true,
      backdrop: "static",
    });

    this.modalVistaPreviaDocumentoComiteRef.result.finally(() => this.cerrarVistaPreviaDocumentoComite());
  }

  private cerrarVistaPreviaDocumentoComite(): void {
    if (this.documentoComitePreviewBlobUrl) {
      window.URL.revokeObjectURL(this.documentoComitePreviewBlobUrl);
    }
    this.documentoComitePreviewBlobUrl = null;
    this.documentoComitePreviewUrl = null;
    this.documentoComitePreviewNombre = "";
    this.modalVistaPreviaDocumentoComiteRef = null;
  }

  onIframeError(): void {
    console.warn("Error al cargar el documento en el iframe");
  }

  abrirDocumentoEnNuevaVentana(): void {
    if (this.documentoComitePreviewBlobUrl) {
      window.open(this.documentoComitePreviewBlobUrl, "_blank");
    } else {
      Swal.fire("Error", "No hay documento para abrir", "error");
    }
  }

  descargarDocumentoComiteActual(): void {
    if (!this.documentoComitePreviewBlobUrl) {
      Swal.fire("Error", "No hay documento seleccionado para descargar.", "error");
      return;
    }

    const link = document.createElement("a");
    link.href = this.documentoComitePreviewBlobUrl;
    link.download = this.documentoComitePreviewNombre || "documento-comite.pdf";
    link.click();
  }

  private async descargarBlobComite(
    blob: Blob,
    contentDisposition?: string | null,
    nombreGuardado?: string,
    numeroComite?: number,
    previsualizar: boolean = false,
  ): Promise<void> {
    const nombreHeader = this.extraerNombreDeContentDispositionComite(contentDisposition || null);
    const extensionHeader = this.extraerExtensionDeNombreComite(nombreHeader);
    const extensionGuardada = this.extraerExtensionDeNombreComite(nombreGuardado);
    const extensionMime = this.extensionDesdeMimeComite(blob.type || "");
    const extensionFirma = await this.extensionDesdeFirmaComite(blob);
    const extensionConfig = this.extensionDesdeConfiguracionComite();
    const extension =
      extensionHeader ||
      extensionGuardada ||
      (extensionMime !== "bin" ? extensionMime : "") ||
      extensionFirma ||
      extensionConfig ||
      "bin";

    const nombreBase = this.construirNombreBaseDocumentoComite(numeroComite) || "DOCUMENTO";
    const nombreDescarga = `${nombreBase}.pdf`;

    if (previsualizar) {
      this.abrirVistaPreviaDocumentoComite(blob, nombreDescarga, numeroComite);
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombreDescarga;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  subirDocumentoSoporteComite(numeroComite?: number): Promise<void> {
    return this.subirDocumentoSoporteComiteConArchivo(
      this.archivoSoporteComite,
      numeroComite,
    );
  }

  private construirCarpetaDocumentoComite(numeroComite?: number): string {
    const sigla = this.configuracionDigitalComite?.siglas || "COM";
    const nit = this.empresaNit ? `${this.empresaNit}/` : "";
    if (numeroComite && Number(numeroComite) > 0) {
      return `${nit}pesv/${sigla}/${numeroComite}`;
    }
    return `${nit}pesv/${sigla}`;
  }

  private construirCarpetaDocumentoComiteCargados(numeroComite?: number): string {
    const sigla = this.configuracionDigitalComite?.siglas || "COM";
    if (numeroComite && Number(numeroComite) > 0) {
      return `${sigla}/${numeroComite}`;
    }
    return sigla;
  }

  private subirDocumentoSoporteComiteConArchivo(
    archivo: File | null,
    numeroComite?: number,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!archivo) {
        console.log("📝 Sin documento adjunto. Se omite subida.");
        resolve();
        return;
      }

      

      if (!this.empresaNit) {
        reject(new Error("No se pudo obtener el NIT de la empresa para guardar el documento del comité."));
        return;
      }

      const nombreCarpeta = `${this.empresaNit}/pesv/documental/acta/comite/`+numeroComite;
      const nombreArchivo = this.construirNombreArchivoDocumentoComite(archivo, numeroComite);

      //console.log(`📤 Subiendo documento: ${nombreArchivo} a ${nombreCarpeta}`);
      //console.log(`📋 Configuración: ID=${this.configuracionDigitalComite.id}, Siglas=${this.configuracionDigitalComite.siglas}`);

      console.log("Archivo a subir:", {
        name: archivo.name,
        size: archivo.size,
        type: archivo.type,
        lastModified: new Date(archivo.lastModified).toISOString(),
      });
      
      
      this.digitalesService
        .subirArchivo(
          archivo,
          numeroComite ?? 0,
          nombreCarpeta,
          nombreArchivo,
          "COMITE_ACTA",
        )
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              const progreso = Math.round((100 * event.loaded) / (event.total || 1));
              //console.log(`📊 Progreso de subida: ${progreso}%`);
            } else if (event.type === HttpEventType.Response) {
              //console.log(`✅ Documento subido exitosamente: ${nombreArchivo}`);
              //console.log(`✅ Respuesta del servidor:`, event.body);
              resolve();
            }
          },
          error: (err: any) => {
            console.error(`❌ Error al subir documento:`, err);
            reject(err);
          },
        });
    });
  }

   private subirDocumentoSoporte(
    archivo: File | null,
    numeroComite?: number,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!archivo) {
        console.log("📝 Sin documento adjunto. Se omite subida.");
        resolve();
        return;
      }

      

      if (!this.empresaNit) {
        reject(new Error("No se pudo obtener el NIT de la empresa para guardar el documento del comité."));
        return;
      }

      const nombreCarpeta = `${this.empresaNit}/pesv/documental/acta/comite/`+numeroComite;
      const nombreArchivo = this.construirNombreArchivoDocumentoComite(archivo, numeroComite);

      //console.log(`📤 Subiendo documento: ${nombreArchivo} a ${nombreCarpeta}`);
      //console.log(`📋 Configuración: ID=${this.configuracionDigitalComite.id}, Siglas=${this.configuracionDigitalComite.siglas}`);

      console.log("Archivo a subir:", {
        name: archivo.name,
        size: archivo.size,
        type: archivo.type,
        lastModified: new Date(archivo.lastModified).toISOString(),
      });
      
      
      this.digitalesService
        .subirArchivo(
          archivo,
          numeroComite ?? 0,
          nombreCarpeta,
          nombreArchivo,
          "COMITE_ACTA",
        )
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              const progreso = Math.round((100 * event.loaded) / (event.total || 1));
              //console.log(`📊 Progreso de subida: ${progreso}%`);
            } else if (event.type === HttpEventType.Response) {
              //console.log(`✅ Documento subido exitosamente: ${nombreArchivo}`);
              //console.log(`✅ Respuesta del servidor:`, event.body);
              resolve();
            }
          },
          error: (err: any) => {
            console.error(`❌ Error al subir documento:`, err);
            reject(err);
          },
        });
    });
  }

  private subirDocumentoSoporteActa(
    archivo: File | null,
    numeroComite?: number,
    numeroActa?:number
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!archivo) {
        console.log("📝 Sin documento adjunto. Se omite subida.");
        resolve();
        return;
      }

      
      if (!this.empresaNit) {
        reject(new Error("No se pudo obtener el NIT de la empresa para guardar el documento del comité."));
        return;
      }

      const nombreCarpeta = `${this.empresaNit}/pesv/documental/acta/comite/`+numeroComite+"/"+numeroActa;
      console.log("Nombre carpeta para subir documento de acta:", nombreCarpeta);
      const nombreArchivo = this.construirNombreArchivoDocumentoComite(archivo, numeroActa);
   
      
      this.digitalesService
        .subirArchivo(
          archivo,
          numeroActa ?? 0,
          nombreCarpeta,
          nombreArchivo,
          "COMITE_ACTA_REUNION",
        )
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
           //   const progreso = Math.round((100 * event.loaded) / (event.total || 1));
           //   console.log(`📊 Progreso de subida: ${progreso}%`);
             // Swal.fire("Aviso", "Acta creada con soporte digital cargado", "success");
                        
            } else if (event.type === HttpEventType.Response) {
              //console.log(`✅ Documento subido exitosamente: ${nombreArchivo}`);
              //console.log(`✅ Respuesta del servidor:`, event.body);
              
              resolve();
            }
          },
          error: (err: any) => {
            console.error(`❌ Error al subir documento:`, err);
            reject(err);
          },
        });
    });
  }
    private extraerListaDocumentos(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }
    if (Array.isArray(response?.archivos)) {
      return response.archivos;
    }
    if (Array.isArray(response?.documentos)) {
      return response.documentos;
    }
    if (Array.isArray(response?.data)) {
      return response.data;
    }
    return [];
  }

  private obtenerNombreDocumento(item: any): string {
    return (
      item?.nombre ||
      item?.name ||
      item?.archivo ||
      item?.filename ||
      item?.fileName ||
      ""
    );
  }

  private normalizarIndicadorDocumentoComite(valor: any): number {
    return Number(valor) === 1 ? 1 : 0;
  }

  private esDocumentoDefaultComite(item: any): boolean {
    if (Number(item?.id_relacion) === this.PUNTO_COMITE || Number(item?.id) === this.PUNTO_COMITE) {
      return true;
    }

    const nombre = this.obtenerNombreDocumento(item).toLowerCase();
    return (
      nombre.includes("default") ||
      nombre.includes("defecto") ||
      nombre.includes("plantilla") ||
      nombre.includes("formato") ||
      nombre.includes("base")
    );
  }

  private obtenerIndicadorDocumentoComiteDesdeIntegrantes(integrantes: any[]): number {
    return integrantes.some((integrante) => this.normalizarIndicadorDocumentoComite(integrante?.documento) === 1)
      ? 1
      : 0;
  }

  private resolverIndicadorDocumentoComite(
    numeroComite: number,
    onResolve: (indicadorDocumento: number) => void,
  ): void {
    const indicadorGuardado = this.indicadorDocumentoComiteMap[numeroComite];
    if (typeof indicadorGuardado === "number") {
      onResolve(indicadorGuardado);
      return;
    }

    const integrantesCargados = this.integrantesExpandidosMap[numeroComite];
    if (Array.isArray(integrantesCargados) && integrantesCargados.length > 0) {
      const indicador = this.obtenerIndicadorDocumentoComiteDesdeIntegrantes(integrantesCargados);
      this.indicadorDocumentoComiteMap[numeroComite] = indicador;
      onResolve(indicador);
      return;
    }

    this.numeroComiteService.getIntegrantesPorNumero(numeroComite).subscribe({
      next: (integrantes: any[]) => {
        const lista = Array.isArray(integrantes) ? integrantes : [];
        const indicador = this.obtenerIndicadorDocumentoComiteDesdeIntegrantes(lista);
        this.indicadorDocumentoComiteMap[numeroComite] = indicador;
        onResolve(indicador);
      },
      error: () => {
        this.indicadorDocumentoComiteMap[numeroComite] = 0;
        onResolve(0);
      },
    });
  }

  private precargarDocumentosComiteHistorial(): void {
    if (!this.configuracionDigitalComite || !this.numerosComiteHistorial?.length) {
      return;
    }

    const visibles = this.numerosComiteHistorial.slice(0, this.pageSize1);
    visibles.forEach((item: any) => {
      const numeroComite = Number(item?.numero);
      if (!numeroComite || this.documentosComitePrecargados.has(numeroComite)) {
        return;
      }

      this.documentosComitePrecargados.add(numeroComite);
     // this.cargarDocumentosComite(numeroComite);
    });
  }

/*   cargarDocumentosComite(numeroComite: number): void {
    if (!this.configuracionDigitalComite) {
      this.documentosComiteMap[numeroComite] = [];
      return;
    }

    const carpetaPorComite = this.construirCarpetaDocumentoComite(numeroComite);
    const carpetaBase = this.construirCarpetaDocumentoComite();
    const carpetaCargadosPorComite = this.construirCarpetaDocumentoComiteCargados(numeroComite);
    const carpetaCargadosBase = this.construirCarpetaDocumentoComiteCargados();
    this.cargandoDocumentosComite[numeroComite] = true;

    const cargarDesdeDigitales = () => {
      this.digitalesService.listarDocumentos(carpetaPorComite).subscribe({
        next: (resp: any) => {
          const docs = this.extraerListaDocumentos(resp);
          if (docs.length > 0) {
            this.documentosComiteMap[numeroComite] = docs;
            this.cargandoDocumentosComite[numeroComite] = false;
            return;
          }

          this.digitalesService.listarDocumentos(carpetaBase).subscribe({
            next: (legacyResp: any) => {
              this.documentosComiteMap[numeroComite] = this.extraerListaDocumentos(legacyResp);
              this.cargandoDocumentosComite[numeroComite] = false;
            },
            error: () => {
              this.documentosComiteMap[numeroComite] = [];
              this.cargandoDocumentosComite[numeroComite] = false;
            },
          });
        },
        error: () => {
          this.documentosComiteMap[numeroComite] = [];
          this.cargandoDocumentosComite[numeroComite] = false;
        },
      });
    };

    const cargarDesdeCargados = () => {
      if (!this.empresaNit) {
        cargarDesdeDigitales();
        return;
      }

      const nit = this.empresaNit;

      this.digitalesService.listarDocumentosPesvCargados(nit, carpetaCargadosPorComite).subscribe({
        next: (resp: any) => {
          const docs = this.extraerListaDocumentos(resp);
          if (docs.length > 0) {
            this.documentosComiteMap[numeroComite] = docs;
            this.cargandoDocumentosComite[numeroComite] = false;
            return;
          }

          this.digitalesService.listarDocumentosPesvCargados(nit, carpetaCargadosBase).subscribe({
            next: (legacyResp: any) => {
              const legacyDocs = this.extraerListaDocumentos(legacyResp);
              if (legacyDocs.length > 0) {
                this.documentosComiteMap[numeroComite] = legacyDocs;
                this.cargandoDocumentosComite[numeroComite] = false;
                return;
              }

              cargarDesdeDigitales();
            },
            error: () => {
              cargarDesdeDigitales();
            },
          });
        },
        error: () => {
          cargarDesdeDigitales();
        },
      });
    };

    this.resolverIndicadorDocumentoComite(numeroComite, (indicadorDocumento) => {
      if (indicadorDocumento === 1) {
        cargarDesdeCargados();
        return;
      }

      cargarDesdeDigitales();
    });
  } */

  obtenerDocumentosComite(numeroComite: number): any[] {
    const docs = this.documentosComiteMap[numeroComite] || [];
    if (!docs.length) {
      return [];
    }

    const indicador = this.normalizarIndicadorDocumentoComite(
      this.indicadorDocumentoComiteMap[numeroComite]
    );

    if (indicador === 1) {
      const cargado = docs.find((doc) => !this.esDocumentoDefaultComite(doc));
      return [cargado || docs[0]];
    }

    const porDefecto = docs.find((doc) => this.esDocumentoDefaultComite(doc));
    return [porDefecto || docs[0]];
  }

  hayDocumentosCargadosComiteActual(): boolean {
    const numeroComiteActual = Number(this.numeroComite || this.formPesv?.get("numeroComite")?.value);
    if (!numeroComiteActual) {
      return false;
    }

    return this.obtenerDocumentosComite(numeroComiteActual).length > 0;
  }

  get numerosComiteHistorialVista(): any[] {
    if (this.filteredNumerosComiteHistorial?.length) {
      return this.filteredNumerosComiteHistorial;
    }

    if (this.searchTextHistorialComite?.trim()) {
      return [];
    }

    return [
      {
        numero: null,
        estado: 1,
        fechainicio: null,
        fechaVigencia: null,
        esDefault: true,
      },
    ];
  }

  private cerrarCargandoDescargaComite(): void {
    if (Swal.isVisible()) {
      Swal.close();
    }
  }




/*   descargarDocumentoComite(numeroComite: number, documento?: any, previsualizar: boolean = false): void {
    if (!this.puedeDispararDescargaComite()) {
      return;
    }

    const carpetaPorComite = this.construirCarpetaDocumentoComite(numeroComite);
    const carpetaBase = this.construirCarpetaDocumentoComite();
    const carpetaCargadosPorComite = this.construirCarpetaDocumentoComiteCargados(numeroComite);
    const carpetaCargadosBase = this.construirCarpetaDocumentoComiteCargados();
    const nombreDocumento = this.obtenerNombreDocumento(documento);
    const formatoComiteId = 2;

    this.abrirCargandoDescargaComite(previsualizar);

    const descargarDesdeDigitales = () => {
      if (nombreDocumento) {
        this.digitalesService.descargarDocumento4ConRespuesta(carpetaPorComite, formatoComiteId, numeroComite, nombreDocumento)
          .pipe(takeUntil(this.descargaComiteCancel$))
          .subscribe({
          next: async (resp: any) => {
            const blob: Blob = resp?.body || resp;
            const contentDisposition = resp?.headers?.get("content-disposition") || null;
            await this.descargarBlobComite(blob, contentDisposition, nombreDocumento, numeroComite, previsualizar);
            this.cerrarCargandoDescargaComite();
          },
          error: () => {
            this.digitalesService.descargarDocumento4ConRespuesta(carpetaBase, formatoComiteId, numeroComite, nombreDocumento)
              .pipe(takeUntil(this.descargaComiteCancel$))
              .subscribe({
              next: async (resp: any) => {
                const blob: Blob = resp?.body || resp;
                const contentDisposition = resp?.headers?.get("content-disposition") || null;
                await this.descargarBlobComite(blob, contentDisposition, nombreDocumento, numeroComite, previsualizar);
                this.cerrarCargandoDescargaComite();
              },
              error: () => {
                this.descargarDocumentoComitePorDefecto(true, false);
              },
            });
          },
        });
        return;
      }

      this.digitalesService.descargarDocumento4ConRespuesta(carpetaPorComite, formatoComiteId, numeroComite)
        .pipe(takeUntil(this.descargaComiteCancel$))
        .subscribe({
        next: async (resp: any) => {
          const blob: Blob = resp?.body || resp;
          if (blob && blob.size > 0) {
            const contentDisposition = resp?.headers?.get("content-disposition") || null;
            await this.descargarBlobComite(blob, contentDisposition, undefined, numeroComite, previsualizar);
            this.cerrarCargandoDescargaComite();
            return;
          }

          this.digitalesService.descargarDocumento4ConRespuesta(carpetaBase, formatoComiteId, numeroComite)
            .pipe(takeUntil(this.descargaComiteCancel$))
            .subscribe({
            next: async (legacyResp: any) => {
              const legacyBlob: Blob = legacyResp?.body || legacyResp;
              if (legacyBlob && legacyBlob.size > 0) {
                const contentDisposition =
                  legacyResp?.headers?.get("content-disposition") || null;
                await this.descargarBlobComite(legacyBlob, contentDisposition, undefined, numeroComite, previsualizar);
                this.cerrarCargandoDescargaComite();
              } else {
                this.descargarDocumentoComitePorDefecto(true, false);
              }
            },
            error: () => {
              this.descargarDocumentoComitePorDefecto(true, false);
            },
          });
        },
        error: () => {
          this.digitalesService.descargarDocumento4ConRespuesta(carpetaBase, formatoComiteId, numeroComite)
            .pipe(takeUntil(this.descargaComiteCancel$))
            .subscribe({
            next: async (legacyResp: any) => {
              const legacyBlob: Blob = legacyResp?.body || legacyResp;
              if (legacyBlob && legacyBlob.size > 0) {
                const contentDisposition =
                  legacyResp?.headers?.get("content-disposition") || null;
                await this.descargarBlobComite(legacyBlob, contentDisposition, undefined, numeroComite, previsualizar);
                this.cerrarCargandoDescargaComite();
              } else {
                this.descargarDocumentoComitePorDefecto(true, false);
              }
            },
            error: () => {
              this.descargarDocumentoComitePorDefecto(true, false);
            },
          });
        },
      });
    };

    const descargarDesdeCargados = () => {
      if (!this.empresaNit) {
        descargarDesdeDigitales();
        return;
      }

      const nit = this.empresaNit;

      if (nombreDocumento) {
        this.digitalesService.descargarDocumento4ConRespuesta(`${nit}/pesv/cargados/${carpetaCargadosPorComite}`, formatoComiteId, numeroComite, nombreDocumento)
          .pipe(takeUntil(this.descargaComiteCancel$))
          .subscribe({
          next: async (resp: any) => {
            const blob: Blob = resp?.body || resp;
            const contentDisposition = resp?.headers?.get("content-disposition") || null;
            await this.descargarBlobComite(blob, contentDisposition, nombreDocumento, numeroComite, previsualizar);
            this.cerrarCargandoDescargaComite();
          },
          error: () => {
            this.digitalesService.descargarDocumento4ConRespuesta(`${nit}/pesv/cargados/${carpetaCargadosBase}`, formatoComiteId, numeroComite, nombreDocumento)
              .pipe(takeUntil(this.descargaComiteCancel$))
              .subscribe({
              next: async (resp: any) => {
                const blob: Blob = resp?.body || resp;
                const contentDisposition = resp?.headers?.get("content-disposition") || null;
                await this.descargarBlobComite(blob, contentDisposition, nombreDocumento, numeroComite, previsualizar);
                this.cerrarCargandoDescargaComite();
              },
              error: () => {
                descargarDesdeDigitales();
              },
            });
          },
        });
        return;
      }

      this.digitalesService.descargarDocumento4ConRespuesta(`${nit}/pesv/cargados/${carpetaCargadosPorComite}`, formatoComiteId, numeroComite)
        .pipe(takeUntil(this.descargaComiteCancel$))
        .subscribe({
        next: async (resp: any) => {
          const blob: Blob = resp?.body || resp;
          if (blob && blob.size > 0) {
            const contentDisposition = resp?.headers?.get("content-disposition") || null;
            await this.descargarBlobComite(blob, contentDisposition, undefined, numeroComite, previsualizar);
            this.cerrarCargandoDescargaComite();
            return;
          }

          this.digitalesService.descargarDocumento4ConRespuesta(`${nit}/pesv/cargados/${carpetaCargadosBase}`, formatoComiteId, numeroComite)
            .pipe(takeUntil(this.descargaComiteCancel$))
            .subscribe({
            next: async (legacyResp: any) => {
              const legacyBlob: Blob = legacyResp?.body || legacyResp;
              if (legacyBlob && legacyBlob.size > 0) {
                const contentDisposition =
                  legacyResp?.headers?.get("content-disposition") || null;
                await this.descargarBlobComite(legacyBlob, contentDisposition, undefined, numeroComite);
                this.cerrarCargandoDescargaComite();
              } else {
                descargarDesdeDigitales();
              }
            },
            error: () => {
              descargarDesdeDigitales();
            },
          });
        },
        error: () => {
          descargarDesdeDigitales();
        },
      });
    };

    const descargarDesdeStorage = () => {
      this.resolverIndicadorDocumentoComite(numeroComite, (indicadorDocumento) => {
        if (indicadorDocumento === 1) {
          descargarDesdeCargados();
          return;
        }

        descargarDesdeDigitales();
      });
    };

    const generarDesdeFormatoConDatos = (datosFormato: any) => {
      const generarDesdeFormato$ = this.formatosService.generarDocumentoPdf(formatoComiteId, datosFormato);

      generarDesdeFormato$
        .pipe(takeUntil(this.descargaComiteCancel$))
        .subscribe({
        next: async (blob: Blob) => {
          const nombreGenerado = `comite_${numeroComite}.pdf`;
          await this.descargarBlobComite(blob, null, nombreGenerado, numeroComite);
          this.cerrarCargandoDescargaComite();
        },
        error: () => {
          // Fallback al flujo tradicional si falla la generación por formato.
          descargarDesdeStorage();
        },
      });
    };

    const generarConIntegrantes = (integrantes: any[]) => {
      const datosFormato = this.construirDatosPlantillaComite(numeroComite, integrantes);
      generarDesdeFormatoConDatos(datosFormato);
    };

    const integrantesCache = this.integrantesExpandidosMap[numeroComite] || [];
    if (Array.isArray(integrantesCache) && integrantesCache.length > 0) {
      generarConIntegrantes(integrantesCache);
      return;
    }

    this.numeroComiteService.getIntegrantesPorNumero(numeroComite)
      .pipe(takeUntil(this.descargaComiteCancel$))
      .subscribe({
      next: (integrantes: any[]) => {
        const lista = Array.isArray(integrantes) ? integrantes : [];
        this.integrantesExpandidosMap[numeroComite] = lista;
        generarConIntegrantes(lista);
      },
      error: () => {
        // Fallback: intentar con datos minimos, backend complementa desde numeroComite.
        generarConIntegrantes([]);
      },
    });
  }
 */
  get acceptDocumentoComite(): string {
    if (!this.formatosPermitidosComite.length) {
      return ".pdf";
    }
    return this.formatosPermitidosComite.map((f) => `.${f}`).join(",");
  }

  get formatosPermitidosComiteTexto(): string {
    return this.formatosPermitidosComite.map((f) => `.${f}`).join(", ");
  }

  get tituloDocumentoComite(): string {
    return (
      this.configuracionDigitalComite?.tipo_documentos ||
      "Documento soporte del comité"
    );
  }

  get puntoDocumentoComite(): number {
    return Number(this.configuracionDigitalComite?.id_relacion) || this.PUNTO_COMITE;
  }

  get mensajeConfiguracionComite(): string {
    return `No se encontró configuración activa para el punto ${this.PUNTO_COMITE} de Comité PESV en Digitales PESV.`;
  }

  filterData(): void {
    const search = normalize(this.searchText);

    this.filteredTableItems = this.pesv.filter((pesv) => {
      const combined = [pesv.cedula, pesv.nombre].map(normalize).join(" ");
      return combined.includes(search);
    });
    this.page1 = 1;
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  aplicarFiltroHistorialComite(): void {
    const termino = normalize(this.searchTextHistorialComite);

    if (!termino) {
      this.filteredNumerosComiteHistorial = [...this.numerosComiteHistorial];
      this.page1 = 1;
      return;
    }

    this.filteredNumerosComiteHistorial = this.numerosComiteHistorial.filter((item: any) => {
      const numero = item?.esDefault ? "default" : String(item?.numero ?? "");
      const estado = item?.esDefault
        ? "por defecto"
        : item?.estado === 1
          ? "activo"
          : "inactivo";
      const fechaInicio = item?.esDefault ? "" : this.formatDateTodo(item?.fechainicio);
      const fechaVigencia = item?.esDefault ? "" : this.formatDateTodo(item?.fechaVigencia);
      const contenido = [numero, estado, fechaInicio, fechaVigencia].map(normalize).join(" ");
      return contenido.includes(termino);
    });

    this.page1 = 1;
  }

  exportarExcelHistorialComite(): void {
    Utils.exportVisibleTableToExcel("tblComiteHistorial", "historial_comites_pesv");
  }

  exportarPdfHistorialComite(): void {
    Utils.exportToPDF("tblComiteHistorial", "historial_comites_pesv", "Historial de Comites PESV");
  }

  onTabChange(event: any): void {
    this.tabActivo = event.nextId;

    // Cargar historial cuando se cambia al tab 2
    if (this.tabActivo === 2) {
      // Asegurar que el filtro esté en "todos" y cargar
      this.filtroComite = "todos";
      this.page1 = 1;
      this.cargarHistorial();
    }

    // En Acta Reunión usar siempre el comité activo, no el próximo número.
    if (this.tabActivo === 3) {
      this.sincronizarNumeroComiteActivoParaActa();
    }
  }

  private obtenerNumeroComiteActivoParaActa(): number | null {
    const desdeIntegrantes = Number(
      this.integrantesActivos?.[0]?.numeroComite ??
        this.integrantesActivos?.[0]?.numero ??
        this.integrantesActivos?.[0]?.NumeroComite,
    );

    if (!Number.isNaN(desdeIntegrantes) && desdeIntegrantes > 0) {
      return desdeIntegrantes;
    }

    const activoHistorial = (this.numerosComiteHistorial || []).find(
      (item: any) => Number(item?.estado) === 1,
    );
    const desdeHistorial = Number(activoHistorial?.numero);
    if (!Number.isNaN(desdeHistorial) && desdeHistorial > 0) {
      return desdeHistorial;
    }

    return null;
  }

  private sincronizarNumeroComiteActivoParaActa(): void {
    const numeroActivo = this.obtenerNumeroComiteActivoParaActa();
    if (numeroActivo) {
      this.formPesv.patchValue({ numeroComite: numeroActivo });
    }
  }

  consultarPersonaByCedula(): void {
    const cedula = this.formPesv.get("cedula")?.value;
    this.cedulaSearch$.next(cedula);
  }

  private buscarPersonaPorCedula(cedula: string): void {
    const cedulaStr = String(cedula).trim();
    if (!cedulaStr) {
      // 🔧 Si no hay cédula, mantener todas las funciones disponibles
      this.updateFuncionesMostrar();
      return;
    }

    this.propietariosService.getCedulaPesv(cedulaStr).subscribe({
      next: (res: any) => {
  //   console.log(res);
     this.propietarioEncontrado ="";
     this.propietarioEncontrado = res;
      console.log("prop", this.propietarioEncontrado.propietario);
      console.log("funciones",this.propietarioEncontrado.cargos[0].funcionesComite);
       

  
        
        if (res?.propietario) {
          
         
          this.funciones_mostrar=this.propietarioEncontrado.cargos[0].funcionesComite;
      
              const nombreCompleto = [
                  res.propietario.primernombre,
                  res.propietario.segundonombre,
                  res.propietario.papellidos,
                  res.propietario.seapellidos
          ]
        .filter(Boolean)
        .join(' ');
          this.formPesv.patchValue({
            nombre:nombreCompleto
        
      });
        } else {
          this.updateFuncionesMostrar();
        }
      },
      error: () => {
        this.updateFuncionesMostrar();
      },
    });
  }





agregarIntegrante(): void {
  const cedula = this.formPesv.get("cedula")?.value;
  const funcionControl = this.formPesv.get("funcion")?.value;

  //console.log("🔍 DEBUG agregarIntegrante:", { funcionControl, funciones_mostrar: this.funciones_mostrar });

  if (!funcionControl) {
    Swal.fire("Advertencia", "Seleccione al menos una función en el comité", "warning");
    return;
  }

  // Normalizar entrada de funciones: puede venir como objeto, id(s) o descripción(es).
  let funcionesArray: string[] = [];
  let nFuncionArray: any[] = [];

 
    nFuncionArray = [Number(funcionControl)];
    funcionesArray = nFuncionArray.map((id: number) => this.obtenerDescripcionFuncion(id) || String(id));
    //console.log("🔍 DEBUG Caso numérico directo:", { nFuncionArray, funcionesArray });


  this.cargando = true;
  //console.log(this.formPesv.get("funcion")?.value);
  //console.log(this.propietarioEncontrado);


  if (this.integrantesComite.some((i) => String(i.cedula) === String(this.propietarioEncontrado.propietario.cedula))) {
        Swal.fire("Info", "Este integrante ya fue agregado", "info");
        return;
  }

   if (this.integrantesComite.some((i) => String(i.idfuncion.descripcion) === String(this.formPesv.get("funcion")?.value.descripcion))) {
        Swal.fire("Info", "Ya existe un colaborador con la función: " + this.formPesv.get("funcion")?.value.descripcion, "info");
        return;
      }    
    // Construir objeto integrante con arrays y funciones_det
  const funcionesDetInicial = this.formatFuncionesDetFromArray(funcionesArray);
  const nombreCompleto = [
                  this.propietarioEncontrado.propietario.primernombre,
                  this.propietarioEncontrado.propietario.segundonombre,
                  this.propietarioEncontrado.propietario.papellidos,
                  this.propietarioEncontrado.propietario.seapellidos
          ]
        .filter(Boolean)
        .join(' ');
          
  const nuevoIntegrante: any = {
        cedula: this.propietarioEncontrado.propietario.cedula,
        nombre: nombreCompleto.toUpperCase(),
        cargoLaboral: this.propietarioEncontrado.propietario.cargoData?.cargos || "",
        idfuncion: funcionControl,
        n_funcion: funcionesDetInicial,
         detallesSeleccionados: [] as string[],
        detalleDescripcion: "",
      };

      console.log(nuevoIntegrante);
      this.integrantesComite.push(nuevoIntegrante);
      console.log(this.integrantesComite);
        // Resetear solo los campos del integrante en el form 
      this.formPesv.patchValue({
        cedula: "",
        nombre: "",
        funcion: "",
      });

  this.cargando = false;
 /*  this.propietariosService.getCedulaPesv(cedula).subscribe({
    next: (resp: any) => {
      console.log(resp);
      this.cargando = false;

      if (!resp?.propietario) {
        Swal.fire("Error", "Colaborador no encontrado", "error");
        return;
      }

      const propietario = resp.propietario;

      // Validar repetido en la tabla local por cédula
      if (this.integrantesComite.some((i) => String(i.cedula) === String(propietario?.cedula))) {
        Swal.fire("Info", "Este integrante ya fue agregado", "info");
        return;
      }

      // Construir objeto integrante con arrays y funciones_det
      const funcionesDetInicial = this.formatFuncionesDetFromArray(funcionesArray);

      // Asignar la primera función seleccionada como n_funcion (valor único para el ng-select)
      const nFuncionInicial = nFuncionArray.length > 0 ? nFuncionArray[0] : null;

      const nuevoIntegrante: any = {
        cedula: propietario.cedula,
        nombre: this.construirNombreCompleto(propietario),
        cargoLaboral: propietario.cargoData?.cargos || "",
        idfuncion: funcionControl,
        // Guardar el id de la función, no el array de descripciones
        funcion: nFuncionInicial,
        // Asignamos la primera función como valor inicial en el ng-select
        n_funcion: nFuncionInicial,
        // detalles seleccionados por fila (array)
        detallesSeleccionados: [] as string[],
        detalleDescripcion: "",
        // funciones_det numerado (string)
        funciones_det: funcionesDetInicial,
      };
      console.log("🔍 DEBUG Nuevo integrante a agregar:", nuevoIntegrante);
      this.integrantesComite.push(nuevoIntegrante);

      // Poblar opciones de detalle para la función seleccionada (sin sobrescribir n_funcion)
      if (nFuncionInicial !== null) {
        nuevoIntegrante._opcionesDetalle = this.obtenerDetallesParaFuncion(nFuncionInicial);
      }

      // Resetear solo los campos del integrante en el form
      this.formPesv.patchValue({
        cedula: "",
        funcion: "",
      });

      this.propietario = null;
      this.updateFuncionesMostrar();

      Swal.fire("Éxito", "Integrante agregado a la tabla", "success");
    },
    error: () => {
      this.cargando = false;
      Swal.fire("Error", "Error al buscar el colaborador", "error");
    },
  }); */
}



  private construirNombreCompleto(propietario: Propietario): string {
    return [
      propietario.primernombre,
      propietario.segundonombre || "",
      propietario.papellidos,
      propietario.seapellidos || "",
    ]
      .filter(Boolean)
      .join(" ")
      .trim();
  }

  private obtenerDescripcionFuncion(funcionId: any): string {
    const idNum = Number(funcionId);
    if (Number.isNaN(idNum)) return String(funcionId || "Sin especificar");
    const funcion = this.funciones_comite.find((f) => Number(f.id) === idNum);
    return funcion?.descripcion || "Sin especificar";
  }

  /**
   * Actualiza la lista de funciones disponibles en el ng-select
   * aplicando reglas por cargo (sin filtrar por unicidad - eso se valida al guardar)
   */
  private updateFuncionesMostrar(
    cargo?: number | string,
    funcionActualId?: number,
  ): void {
    // 🔧 Verificar que funciones_comite tenga datos antes de proceder
    if (!this.funciones_comite || this.funciones_comite.length === 0) {
      return;
    }

    let base = [...this.funciones_comite];

    // Reglas por cargo
    // Si se recibió la descripción del cargo (string), filtrar por las reglas
    if (typeof cargo === "string" && cargo.trim()) {
      const cargoDesc = cargo.toString().trim().toUpperCase();
      base = base.filter((f) => {
        // Siempre incluir la función actual para no perderla al editar
        if (f.id === funcionActualId) return true;
       // return this.esCargoPermitidoParaFuncion(f.descripcion || "", cargoDesc as string);
      });
    } else if (typeof cargo === "number") {
      // Compatibilidad con códigos numéricos previos
      if (cargo === 2) {
        base = base.filter((f) => f.id === 3 || f.id === funcionActualId);
      } else if (cargo === 3) {
        base = base.filter(
          (f) => (f.id && [1, 3].includes(f.id)) || f.id === funcionActualId,
        );
      }
    }

    // Nota: No filtramos funciones duplicadas aquí.
    // Se valida al guardar con Swal de confirmación.

    this.funciones_mostrar = base;
  }

  /**
   * Mapa de funciones a cargos permitidos.
   * Las claves son descripciones de función tal como aparecen en la BD/UI.
   */
/*   private readonly FUNCION_ALLOWED_CARGOS: { [funcion: string]: string[] } = {
    "REPRESENTANTE DE LA ALTA DIRECCIÓN": ["GERENTE"],
    "LÍDER COMPORTAMIENTO HUMANO": ["AUXILIAR ADMINISTRATIVA", "SECRETARIA"],
    "LÍDER VEHÍCULOS SEGUROS": ["CONDUCTOR"],
    "LÍDER INFRAESTRUCTURA SEGURA": ["MENSAJERO", "AUXILIAR ADMINISTRATIVA"],
    "LÍDER ATENCIÓN A VÍCTIMAS": ["SECRETARIA", "AUXILIAR ADMINISTRATIVA"],
    "LÍDER DISEÑO E IMPLEMENTACIÓN PESV": ["GERENTE", "AUXILIAR ADMINISTRATIVA"],
  }; */

 /*  private esCargoPermitidoParaFuncion(funcionDescripcion: string, cargoDescripcion: string): boolean {
    if (!funcionDescripcion) return true; // sin función seleccionada => permitir
    const key = (funcionDescripcion || "").toString().trim().toUpperCase();
    const cargoNorm = (cargoDescripcion || "").toString().trim().toUpperCase();

    const permitidos = this.FUNCION_ALLOWED_CARGOS[key];
    if (!permitidos || permitidos.length === 0) {
      // Si no hay regla explícita, permitir por compatibilidad
      return true;
    }

    return permitidos.map((c) => c.toUpperCase()).includes(cargoNorm);
  } */

  /**
   * Verifica si una función ya está asignada a otro integrante en el comité actual.
   * Si editingIntegranteId es provisto, se excluye ese integrante de la búsqueda.
   */
  private esFuncionYaAsignada(funcionDescripcion: string, editingIntegranteId?: number): boolean {
    if (!funcionDescripcion) return false;
    const funcionNorm = funcionDescripcion.trim().toUpperCase();
    
    return this.integrantesComite.some((integrante) => {
      // Si estamos editando, excluir el integrante actual
      if (editingIntegranteId && integrante.id === editingIntegranteId) {
        return false;
      }
      const fnDescNorm = (integrante.funcion || "").trim().toUpperCase();
      return fnDescNorm === funcionNorm;
    });
  }

private isFuncionAsignada(idFuncion: number): boolean {

  console.log("🔍 DEBUG Verificando función asignada:", {
    idFuncion,
    integrantes: this.integrantesModalListaFiltrada
  });

  return this.integrantesModalListaFiltrada.some((integrante) =>
    Number(integrante?.funcionDetalle?.id) === Number(idFuncion) &&
    Number(integrante?.estado) === 1
  );
}

  // Devuelve funciones disponibles para un integrante concreto usando su cargo (texto) y
  // excluyendo funciones ya asignadas a otros integrantes, pero permitiendo la propia.
  obtenerFuncionesParaIntegrante(integrante: any): FuncionComiteAttributes[] {
    const cargoDesc = integrante?.cargoLaboral || integrante?.cargo_descripcion || "";
    if (!this.funciones_comite || this.funciones_comite.length === 0) return [];

    let base = [...this.funciones_comite];

    // Si hay reglas por descripción de cargo, aplicar filtrado similar a updateFuncionesMostrar
    if (typeof cargoDesc === "string" && cargoDesc.trim()) {
      const cargoNorm = cargoDesc.trim().toUpperCase();
     // base = base.filter((f) => this.esCargoPermitidoParaFuncion(f.descripcion || "", cargoNorm));
    }

    // Excluir funciones asignadas a otros integrantes (mantener si ya pertenece a este integrante)
    const assigned = (this.integrantesComite || []).filter(i => i !== integrante)
      .flatMap(i => (Array.isArray(i.n_funcion) ? i.n_funcion : (i.n_funcion ? [i.n_funcion] : []))).map((v: any) => Number(v));

    base = base.filter((f) => !assigned.includes(Number(f.id)));

    return base;
  }

  onSeleccionFuncionIntegrante(integrante: any, funcionId: any): void {
    // ng-select may emit the value (id) or the selected item (object).
    let raw = funcionId;
    if (raw && typeof raw === 'object') {
      // try common properties
      raw = (raw.value !== undefined) ? raw.value : (raw.id !== undefined ? raw.id : (raw.n_funcion !== undefined ? raw.n_funcion : raw));
    }
    const idNum = raw != null && raw !== "" ? Number(raw) : null;
    integrante.n_funcion = idNum;
    // Asignar descripción legible usando el helper (maneja tipos)
    integrante.funcion = idNum ? this.obtenerDescripcionFuncion(idNum) : (integrante.funcion || "");

    // Al cambiar la función, limpiar detalle previo
    integrante.n_detalle = null;
    integrante.detalleDescripcion = "";
    integrante.detallesSeleccionados = [];

    // Poblar opciones de detalle para este integrante (cache local)
    integrante._opcionesDetalle = this.obtenerDetallesParaFuncion(integrante.n_funcion || idNum);
  }

  onSeleccionDetalleIntegrante(integrante: any, nDetalle: any): void {
    // Soporta selección múltiple o única. Normalizar a array de números cuando aplique.
    if (Array.isArray(nDetalle)) {
      const valores = nDetalle.map((item: any) => {
        if (item && typeof item === 'object') return Number(item.value ?? item.n_detalle ?? item);
        return Number(item);
      }).filter((v: any) => !Number.isNaN(Number(v)));

      integrante.detallesSeleccionados = valores;

      // Generar etiquetas legibles para los detalles seleccionados
      const opciones = integrante._opcionesDetalle && integrante._opcionesDetalle.length ? integrante._opcionesDetalle : this.obtenerDetallesParaFuncion(integrante.n_funcion);
      const etiquetas = valores.map((val: any) => opciones.find((o: any) => Number(o.value) === Number(val))?.label || this.obtenerDescripcionDetallePorNumero(val, integrante?.n_funcion)).filter((t: any) => !!t);

      integrante.detalleDescripcion = etiquetas.join(', ');
      integrante.funciones_det = etiquetas.length ? this.formatFuncionesDetFromArray(etiquetas) : null;
      // Mantener n_detalle vacío si usamos múltiples
      integrante.n_detalle = null;
      return;
    }

    // Caso único (compatibilidad): mantener comportamiento anterior
    let raw = nDetalle;
    if (raw && typeof raw === 'object') {
      raw = (raw.value !== undefined) ? raw.value : (raw.n_detalle !== undefined ? raw.n_detalle : raw);
    }
    const detalleNum = raw != null && raw !== "" ? Number(raw) : null;
    integrante.n_detalle = detalleNum;
    integrante.detallesSeleccionados = detalleNum ? [detalleNum] : [];
    // Generar etiqueta legible
    const opciones = integrante._opcionesDetalle && integrante._opcionesDetalle.length ? integrante._opcionesDetalle : this.obtenerDetallesParaFuncion(integrante.n_funcion);
    const etiqueta = opciones.find((o: any) => Number(o.value) === Number(detalleNum))?.label || "";
    integrante.detalleDescripcion = etiqueta;
    integrante.funciones_det = etiqueta ? this.formatFuncionesDetFromArray([etiqueta]) : null;
  }

  private obtenerDescripcionDetallePorNumero(nDetalle: any, nFuncion?: any): string {
    const nDetalleNum = Number(nDetalle);
    if (!nDetalleNum) return "";

    const opcionesPorFuncion = this.obtenerDetallesParaFuncion(Number(nFuncion));
    const detalleFuncion = opcionesPorFuncion.find((item) => Number(item.value) === nDetalleNum);
    if (detalleFuncion?.label) return detalleFuncion.label;

    const detalleGlobal = (this.opcionesNDetalle || []).find((item) => Number(item.value) === nDetalleNum);
    if (detalleGlobal?.label) return detalleGlobal.label;

    const detalleCatalogo = this.funcionesIntegranteDetalle
      .flatMap((item: any) => (Array.isArray(item?.detalles) ? item.detalles : []))
      .find((detalle: any) => Number(detalle?.n_detalle) === nDetalleNum);

    return (
      detalleCatalogo?.funcionesDetIntegrantes?.descripcion ||
      detalleCatalogo?.descripcion ||
      `Detalle ${nDetalleNum}`
    );
  }

  private construirFuncionesDetDesdeIntegrante(integrante: any): string | null {
    const detallesSeleccionados = Array.isArray(integrante?.detallesSeleccionados)
      ? integrante.detallesSeleccionados
      : this.ensureArray(integrante?.detallesSeleccionados);

    if (detallesSeleccionados.length > 0) {
      const etiquetas = detallesSeleccionados
        .map((nDetalle: any) => this.obtenerDescripcionDetallePorNumero(nDetalle, integrante?.n_funcion))
        .filter((et: string) => !!et);
      const texto = this.formatFuncionesDetFromArray(etiquetas);
      if (texto) return texto;
    }

    if (integrante?.n_detalle) {
      const etiqueta = this.obtenerDescripcionDetallePorNumero(integrante.n_detalle, integrante?.n_funcion);
      const texto = this.formatFuncionesDetFromArray(etiqueta ? [etiqueta] : []);
      if (texto) return texto;
    }

    if (integrante?.detalleDescripcion) {
      const texto = this.formatFuncionesDetFromArray(this.ensureArray(integrante.detalleDescripcion));
      if (texto) return texto;
    }

    return integrante?.funciones_det || null;
  }

  /**
   * Auto-selecciona la primera función disponible para un integrante
   * y pobla automáticamente las opciones de detalle
   */
  autoSeleccionarPrimeraFuncion(integrante: any): void {
    const funciones = this.obtenerFuncionesParaIntegrante(integrante);
    if (funciones && funciones.length > 0) {
      const primeraFuncion = funciones[0];
      integrante.n_funcion = Number(primeraFuncion.id);
      integrante.funcion = primeraFuncion.descripcion;
      // Poblar opciones de detalle automáticamente
      integrante._opcionesDetalle = this.obtenerDetallesParaFuncion(primeraFuncion.id);
    }
  }

  /**
   * Verifica si el rol único (Presidente/Secretario) ya fue seleccionado
   */
  private existeRolUnicoSeleccionado(funcionId: any): boolean {
    const desc = this.obtenerDescripcionFuncion(funcionId);
    const descNorm = normalize(desc);
    if (["presidente", "secretario"].includes(descNorm)) {
      return this.integrantesComite.some(
        (i) => normalize(i.funcion) === descNorm,
      );
    }
    return false;
  }

  /**
   * Convertir fecha a formato YYYY-MM-DD para inputs
   */
  private toInputDate(fecha: string | Date | null | undefined): string {
    try {
      if (!fecha) return "";
      const d = new Date(fecha);
      if (isNaN(d.getTime())) return "";
      return d.toISOString().slice(0, 10);
    } catch {
      return "";
    }
  }

  private inicializarFechas(): void {
    const hoy = new Date();

    // Fecha máxima para designación: hoy (solo fechas pasadas/presentes)
    this.fechaMaxDesignacion = this.formatearFechaParaInput(hoy);
    this.fechaMinVigenciaDesde = this.formatearFechaParaInput(hoy);

    // Fecha mínima para vencimiento: 1 año desde hoy
    const fechaMinVenc = new Date();
    fechaMinVenc.setFullYear(fechaMinVenc.getFullYear() + 1);
    this.fechaMinVencimiento = this.formatearFechaParaInput(fechaMinVenc);

    // Inicializar fecha mínima para vigenciaHasta (3 meses desde hoy por defecto)
    const fechaMin3Meses = new Date();
    fechaMin3Meses.setMonth(fechaMin3Meses.getMonth() + 3);
    this.fechaMinVigenciaHasta = this.formatearFechaParaInput(fechaMin3Meses);
  }

  private formatearFechaParaInput(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const día = String(fecha.getDate()).padStart(2, "0");
    return `${año}-${mes}-${día}`;
  }

  private fechaNoPasadaValidator = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    if (!control.value) return null;

    const fecha = new Date(control.value);
    if (isNaN(fecha.getTime())) return { fechaInvalida: true };

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    fecha.setHours(0, 0, 0, 0);

    return fecha < hoy ? { fechaPasada: true } : null;
  };

  onFechaInicioChange(): void {
    const fechaInicio = this.formPesv.get("fechainicio")?.value;

    if (fechaInicio) {
      const fecha = new Date(fechaInicio);
      const fechaVigencia = new Date(fecha);
      fechaVigencia.setFullYear(fechaVigencia.getFullYear() + 1);

      // Auto-completar el campo de vigencia con la fecha calculada
      const fechaVigenciaFormato = this.formatearFechaParaInput(fechaVigencia);
      this.formPesv.patchValue({
        fechaVigencia: fechaVigenciaFormato,
      });
    }
  }

  onVigenciaDesdeChange(): void {
    const vigenciaDesde = this.formPesv.get("vigenciaDesde")?.value;
    if (vigenciaDesde) {
      const fechaDesde = new Date(vigenciaDesde);
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      if (fechaDesde < hoy) {
        this.formPesv.get("vigenciaDesde")?.setErrors({ fechaPasada: true });
        return;
      }

      // Calcular fecha mínima: 3 meses desde vigenciaDesde
      const fechaMinima = new Date(fechaDesde);
      fechaMinima.setMonth(fechaMinima.getMonth() + 3);
      this.fechaMinVigenciaHasta = this.formatearFechaParaInput(fechaMinima);

      // Validar si vigenciaHasta actual es menor al mínimo
      const vigenciaHasta = this.formPesv.get("vigenciaHasta")?.value;
      if (vigenciaHasta) {
        const fechaHasta = new Date(vigenciaHasta);
        if (fechaHasta < fechaMinima) {
          // Limpiar vigenciaHasta si es menor al mínimo
          this.formPesv.patchValue({ vigenciaHasta: "" });
        }
      }
    }
  }

  private cargarFuncionesComite(): void {
    this.funcionComiteService.getAll().subscribe({
      next: (funciones: any) => {
        const funcionesArray = Array.isArray(funciones)
          ? funciones
          : (funciones as any)?.data || [];
        this.funciones_comite = funcionesArray;
        this.funciones_mostrar = [...funcionesArray];
      },
      error: () => {
        this.funciones_mostrar = [];
      },
    });
  }

  private cargarMotivos(): void {
    this.comiteMotivoService.getAll().subscribe({
      next: (motivos: any) => {
        const motivosArray = Array.isArray(motivos)
          ? motivos
          : (motivos as any)?.data || [];
        this.comiteMotivo = motivosArray;
      },
      error: () => {
        this.comiteMotivo = [];
      },
    });
  }

  private cargarMotivos2(): void {
    this.comiteMotivoService.getmotivos2().subscribe({
      next: (motivos: any) => {
        const motivosArray = Array.isArray(motivos)
          ? motivos
          : (motivos as any)?.data || [];
        this.comiteMotivo2 = motivosArray;
      },
      error: () => {
        this.comiteMotivo2 = [];
      },
    });
  }

    private cargartipoActa(): void {
    this.comiteTipoActaService.getAll().subscribe({
      next: (acta: any) => {
       //console.log("🔍 DEBUG Tipo de acta recibida:", acta);
        const motivosArray = Array.isArray(acta)
          ? acta
          : (acta as any)?.data || [];
        this.tipoActa = motivosArray;
      },
      error: () => {
        this.tipoActa = [];
      },
    });
  }

  private cargarComtiteActivos(): void {
    this.comiteService.getAllActivos().subscribe({
      next: (integrantes: any) => {
        const integrantesArray = Array.isArray(integrantes)
          ? integrantes
          : (integrantes as any)?.data || [];
        this.integrantesActivos = integrantesArray;
        this.sincronizarNumeroComiteActivoParaActa();
      },
      error: () => {
        this.integrantesActivos = [];
      },
    });
  }

  private recargarSelects(): void {
    this.cargarMotivos();
    this.cargarMotivos2();
    this.cargartipoActa();
    this.cargarFuncionesComite();
    this.cargarComtiteActivos();
  }

  formatDateTodo(date: any): string {
    if (!date) return "";
    try {
      return new Date(date).toLocaleDateString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    } catch {
      return date;
    }
  }

 
 
  eliminarIntegrante(index: number): void {
    if (index >= 0 && index < this.integrantesComite.length) {
      this.integrantesComite.splice(index, 1);
      // Actualizar opciones del ng-select (roles únicos vuelven a estar disponibles)
      this.updateFuncionesMostrar();
      Swal.fire("Éxito", "Integrante eliminado de la lista", "success");
    }
  }

  // ============ MÉTODOS HELPER ============

  private mostrarError(error: any, contexto: string): void {
    this.cargando = false;
    const { titulo, mensaje } = this.obtenerMensajeError(error, contexto);
    Swal.fire({
      icon: "error",
      title: titulo,
      text: mensaje,
      confirmButtonText: "Aceptar",
    });
    console.error(`❌ ${contexto}:`, error);
  }

  private obtenerMensajeError(
    error: any,
    contextoDefault: string,
  ): { titulo: string; mensaje: string } {
    const mapeoErrores: { [key: number]: { titulo: string; mensaje: string } } =
      {
        0: {
          titulo: "Error de conexión",
          mensaje: "No se puede conectar con el servidor",
        },
        400: {
          titulo: "Error de validación",
          mensaje: error?.error?.error || "Los datos enviados no son válidos",
        },
        500: {
          titulo: "Error del servidor",
          mensaje: "Revisa los logs del backend",
        },
      };

    return (
      mapeoErrores[error?.status] || {
        titulo: contextoDefault,
        mensaje:
          error?.error?.error ||
          `Ocurrió un error en ${contextoDefault.toLowerCase()}`,
      }
    );
  }



  private prepararIntegrantesParaGuardar(
    numeroComite: number,
  ): ComiteIntegrante[] {
    const documento = this.archivoSoporteComite ? 1 : 0;

    return this.integrantesComite.map((i) => {
      const funcionId = i.n_funcion ?? (Number(i.funcion) > 0 ? Number(i.funcion) : null);
      return {
        numeroComite,
        cedula: i.cedula,
        nombre: i.nombre,
        cargoLaboral: i.cargoLaboral,
        funcion: funcionId,
        funciones_det: this.construirFuncionesDetDesdeIntegrante(i),
        n_detalle: i.n_detalle || null, // Incluir el detalle seleccionado
        documento,
      };
    });
  }

 
  

  private resetearFormularioComite(): void {
    this.integrantesComite = [];
    this.comiteContinuado = false;
    this.formPesv.patchValue({
      cedula: "",
      funcion: "",
    });
    this.propietario = null;
    this.inicializarFechas();
    this.cargarHistorial();
    this.obtenerProximoNumeroComite();
    this.recargarSelects();
  }

  // ============ GUARDAR COMITÉ ============

guardarComite(): void {

  if (!this.numeroComite) {
    Swal.fire('Advertencia', 'No hay número de comité asignado', 'warning');
    return;
  }

  if (!Array.isArray(this.integrantesComite) || this.integrantesComite.length < 3) {
    Swal.fire('Advertencia', 'Se requieren al menos 3 integrantes', 'warning');
    return;
  }

  if (!this.archivoSoporteComite) {
    Swal.fire('Advertencia', 'Debe cargar el archivo digital del comité en formato PDF', 'warning');
    return;
  }

  const numeroComiteActual = Number(this.numeroComite);
  const archivoParaSubir = this.archivoSoporteComite;

  const integrantesPayload = this.integrantesComite.map((i: any) => {
  //const funcionesArr = Array.isArray(i.funcion) ? i.funcion : this.ensureArray(i.funcion);
  //const detallesArr = Array.isArray(i.detallesSeleccionados) ? i.detallesSeleccionados : this.ensureArray(i.detallesSeleccionados);
    //let funcionesDetFinal: string | null = null;
    //const funcionId = i.n_funcion ?? (Number(i.funcion) > 0 ? Number(i.funcion) : null);
    console.log(i);
    return {
      cedula: i.cedula,
      nombre: i.nombre,
      cargoLaboral: i.cargoLaboral,
      funcion: i.idfuncion.id,
      funciones_det:  i.idfuncion.descripcion,
      numeroComite: numeroComiteActual,
      estado: i.estado ?? 1,
      motivo: null,
      observaciones: null,
      documento: i.documento ?? null,
    };
  });


  this.cargandoGuardar = true;
 // console.log(integrantesPayload);
  this.comiteService.createBatch({ numeroComite: numeroComiteActual, integrantes: integrantesPayload })
    .subscribe({
      next: async (res: any) => {
        console.log(res);
        let uploadError = false;

        try {
          await this.guardarIntegrantesEnHistorial(numeroComiteActual);
        } catch (err) {
          console.error('Error guardando historial tras crear comité:', err);
          this.cargarHistorial();
          this.cargarComtiteActivos();
        }

        try {
          console.log('Subiendo documento digital del comité a Google...');
          console.log('Archivo a subir:', archivoParaSubir);
          console.log('Número de comité:', numeroComiteActual);
          await this.subirDocumentoSoporteComiteConArchivo(archivoParaSubir, numeroComiteActual);
        } catch (err) {
          uploadError = true;
          console.error('Error subiendo documento digital del comité a Google:', err);
        }

        this.cargandoGuardar = false;
        this.cargarHistorial();
        this.cargarComtiteActivos();
        this.sincronizarNumeroComiteActivoParaActa();
        this.tabActivo = 3;
        this.reiniciarComite();

        if (uploadError) {
          Swal.fire('Advertencia', 'Comité guardado, pero no se pudo subir el archivo digital a Google.', 'warning');
        } else {
          Swal.fire('Éxito', 'Comité guardado correctamente y el archivo digital cargado.', 'success');
        }
      },
      error: (err: any) => {
        this.cargandoGuardar = false;
        console.error('Error guardando comité', err);
        Swal.fire('Error', err?.error?.error || 'Error al guardar comité', 'error');
      }
    });
}

  private guardarIntegrantesEnHistorial(numeroComite: number): Promise<void> {
    const promesas = this.integrantesComite.flatMap((integrante) => {

        console.log(integrante);




      // Si no hay detalle, guardar al menos la función (o 0)

      const payload = {
        n_comite: numeroComite,
        cedula: integrante.cedula,
        funcion: integrante?.idfuncion.id || 0,
        estado: 1,
      };
      return [this.funcionHistorialComiteService.create(payload as any).toPromise()];
    });

    return Promise.all(promesas)
      .then(() => {
        console.log("✅ Historial de funciones guardado correctamente");
      })
      .catch((error) => {
        console.error("❌ Error al guardar historial:", error);
        throw error;
      });
  }



  cargarHistorial(): void {
    this.cargandoHistorial = true;
    this.page1 = 1; // Reiniciar a página 1 al cambiar filtro

    let observable: Observable<NumeroComiteResponse[]>;

    switch (this.filtroComite) {
      case "activos":
        observable = this.numeroComiteService.getAllActivos();
        break;
      case "inactivos":
        observable = this.numeroComiteService.getAllInactivos();
        break;
      default:
        observable = this.numeroComiteService.getAll();
    }

    observable.subscribe({
      next: (res: any) => {
        this.cargandoHistorial = false;

        // Si viene como array o { data: [] }
        const datos = Array.isArray(res) ? res : (res?.data ?? []);

        this.numerosComiteHistorial = datos;

        // Ordenar activos primero solo si no estamos filtrando
        if (this.filtroComite === "todos") {
          this.numerosComiteHistorial.sort((a, b) => {
            if (a.estado === b.estado) return 0;
            return a.estado === 1 ? -1 : 1;
          });
          //console.log(`🔀 Datos ordenados (activos primero)`);
        }

        this.aplicarFiltroHistorialComite();

        this.precargarDocumentosComiteHistorial();
      },
      error: (err: any) => {
        this.cargandoHistorial = false;
        console.error(`❌ Error al cargar historial:`, err);
        Swal.fire(
          "Error",
          "No se pudieron cargar los números de comité",
          "error",
        );
      },
    });
  }

  /**
   * Cambiar filtro de comités
   */
  cambiarFiltroComite(filtro: "todos" | "activos" | "inactivos"): void {
    if (this.filtroComite !== filtro) {
      this.filtroComite = filtro;
      this.documentosComitePrecargados.clear();
      this.searchTextHistorialComite = "";
      // Limpiar datos expandidos cuando cambias de filtro
      this.integrantesExpandidosMap = {};
      this.actasExpandidas = {};
      this.actasExpandidasMap = {};
      this.actasAgrupadasMap = {};
      this.actaGrupoExpandido = {};
      this.cargarHistorial();
    }
  }

  /**
   * Cargar integrantes para un número de comité específico
   */
  cargarIntegrantesPorNumero(numeroComite: number): void {
    this.cargarIntegrantesComite(numeroComite);
  }

  private cargarIntegrantesComite(
    numeroComite: number,
    sincronizarModal: boolean = false,
  ): void {
    this.cargandoIntegrantes[numeroComite] = true;
    if (sincronizarModal) {
      this.cargandoIntegrantesModal = true;
    }

    this.numeroComiteService.getIntegrantesPorNumero(numeroComite).subscribe({
      next: (integrantes: any[]) => {
        this.cargandoIntegrantes[numeroComite] = false;
        const lista = Array.isArray(integrantes) ? integrantes : [];
        this.integrantesExpandidosMap[numeroComite] = lista;
        this.indicadorDocumentoComiteMap[numeroComite] =
          this.obtenerIndicadorDocumentoComiteDesdeIntegrantes(lista);

        if (
          sincronizarModal &&
          this.numeroComiteIntegrantesModal === numeroComite
        ) {
          this.integrantesModalLista = [...lista];
          this.aplicarFiltroIntegrantesModal();
          this.cargandoIntegrantesModal = false;
        }

        //this.cargarDocumentosComite(numeroComite);
      },
      error: (err) => {
        this.cargandoIntegrantes[numeroComite] = false;
        this.documentosComiteMap[numeroComite] = [];

        if (
          sincronizarModal &&
          this.numeroComiteIntegrantesModal === numeroComite
        ) {
          this.integrantesModalLista = [];
          this.integrantesModalListaFiltrada = [];
          this.cargandoIntegrantesModal = false;
        }

        Swal.fire(
          "Error",
          `No se pudieron cargar los integrantes del comité No. ${numeroComite}`,
          "error",
        );
        console.error(err);
      },
    });
  }

  abrirModalIntegrantes(comite: any): void {
    const numeroComite = Number(comite?.numero);
    if (Number.isNaN(numeroComite) || numeroComite <= 0) {
      return;
    }

    this.numeroComiteIntegrantesModal = numeroComite;
    this.estadoComiteIntegrantesModal = Number(comite?.estado);
    this.searchTextIntegrantesModal = "";
    this.pageIntegrantesModal = 1;
    this.cargandoIntegrantesModal = true;
    this.integrantesModalLista = [];
    this.integrantesModalListaFiltrada = [];

    // Cargar datos ANTES de abrir el modal
    this.numeroComiteService.getIntegrantesPorNumero(numeroComite).subscribe({
      next: (integrantes: any[]) => {
        console.log(`Integrantes cargados para comité ${numeroComite}:`, integrantes);
        const lista = Array.isArray(integrantes) ? integrantes : [];
        this.integrantesModalLista = [...lista];
        this.integrantesExpandidosMap[numeroComite] = lista;
        //this.indicadorDocumentoComiteMap[numeroComite] = this.obtenerIndicadorDocumentoComiteDesdeIntegrantes(lista);
        
        this.aplicarFiltroIntegrantesModal();
        this.cargandoIntegrantesModal = false;

        // Abrir el modal DESPUÉS de cargar los datos
        if (this.modalIntegrantesComite) {
          this.modalIntegrantesComiteRef = this.modalService.open(
            this.modalIntegrantesComite,
            {
              size: "xl",
              centered: true,
              backdrop: "static",
              keyboard: false,
            },
          );
        }

      //  this.cargarDocumentosComite(numeroComite);
      },
      error: (err) => {
        this.cargandoIntegrantesModal = false;
        this.integrantesModalLista = [];
        this.integrantesModalListaFiltrada = [];

        Swal.fire(
          "Error",
          `No se pudieron cargar los integrantes del comité No. ${numeroComite}`,
          "error",
        );
        console.error(err);
      },
    });
  }

  aplicarFiltroIntegrantesModal(): void {
    const termino = normalize(this.searchTextIntegrantesModal);
    if (!termino) {
      this.integrantesModalListaFiltrada = [...this.integrantesModalLista];
      this.pageIntegrantesModal = 1;
      return;
    }

    this.integrantesModalListaFiltrada = this.integrantesModalLista.filter(
      (item: any) => {
        const estadoTexto = Number(item?.estado) === 1 ? "activo" : "inactivo";
        return [
          item?.cedula,
          item?.nombre,
          item?.cargoLaboral,
          item?.funcion,
          item?.ComiteMotivoData?.descripcion,
          estadoTexto,
        ].some((valor) => normalize(valor).includes(termino));
      },
    );

    this.pageIntegrantesModal = 1;
  }

  exportarExcelIntegrantesModal(): void {
    if (!this.numeroComiteIntegrantesModal) {
      return;
    }
    Utils.exportVisibleTableToExcel(
      "tblIntegrantesModal",
      `integrantes_comite_${this.numeroComiteIntegrantesModal}`,
    );
  }

  exportarPdfIntegrantesModal(): void {
    if (!this.numeroComiteIntegrantesModal) {
      return;
    }
    Utils.exportToPDF(
      "tblIntegrantesModal",
      `integrantes_comite_${this.numeroComiteIntegrantesModal}`,
      `Integrantes Comite ${this.numeroComiteIntegrantesModal}`,
    );
  }

  private refrescarIntegrantesModalSiAplica(numeroComite: number): void {
    if (this.numeroComiteIntegrantesModal !== numeroComite) {
      return;
    }

    this.cargarIntegrantesComite(numeroComite, true);
  }

  /**
   * Toggle para mostrar/ocultar integrantes de un comité
   */
  toggleIntegrantesExpandidos(numeroComite: number): void {
    if (this.integrantesExpandidosMap[numeroComite]) {
      delete this.integrantesExpandidosMap[numeroComite];
    } else {
      this.cargarIntegrantesPorNumero(numeroComite);
    }
  }

  /**
   * Editar integrante del comité
   */
  editarIntegrante(numeroComite: number, integrante: any): void {
    // Guardar referencias para usar en el método de guardar

    console.log("Editando integrante:", integrante, "del comité No.", numeroComite);  
    //console.log( this.integrantesModalLista);
    this.integranteEnEdicion = integrante;
    this.numeroComiteEnEdicion = numeroComite;

     this.propietariosService.getCedulaPesv(integrante.cedula).subscribe({
      next: (res: any) => {
       // console.log(`📊 Respuesta de búsqueda completa:`, res.cargos);
        this.listaFunciones = res.cargos[0].funcionesComite.map(f => ({
        id: f.funcion.id,
        descripcion: f.funcion.descripcion
      }));
        //console.log(this.listaFunciones);
        if(this.listaFunciones.length>0){
          this.funciones_mostrar = this.listaFunciones;
        }
        
      } 
    });


    console.log("Función del integrante:",  integrante.funcionDetalle.id);
    // Cargar datos en el formulario
    this.formEditarIntegrante.patchValue({
      cedula: integrante.cedula,
      nombre: integrante.nombre,
      cargoLaboral: integrante.cargoLaboral || "",
      funcion: integrante.funcionDetalle.id, // Usar el ID, no la descripción
      estado: integrante.estado ?? 1,
    });

 

    // Abrir modal de editar 
    if (this.modalEditarIntegrante) {
      this.modalEditarIntegranteRef = this.modalService.open(
        this.modalEditarIntegrante,
        {
          size: "xl",
          centered: true,
          backdrop: "static",
          keyboard: false,
        },
      );
    }
  }

  guardarCambiosIntegrante(modalRef: any): void {
    if (!this.formEditarIntegrante.valid) {
      Swal.fire(
        "Validación",
        "Por favor completa todos los campos obligatorios",
        "warning",
      );
      return;
    }

    if (!this.integranteEnEdicion || !this.numeroComiteEnEdicion) {
      Swal.fire("Error", "No hay integrante en edición", "error");
      return;
    }

    this.cargandoGuardar = true;

    // Obtener la descripción de la función basado en el ID seleccionado
    const funcionId = this.formEditarIntegrante.get("funcion")?.value;
    const funcionDescripcion = this.obtenerDescripcionFuncion(funcionId);

    const payload: ComiteRegistro = {
      numeroComite: this.numeroComiteEnEdicion,
      cedula: Number(this.integranteEnEdicion.cedula),
      nombre: this.integranteEnEdicion.nombre,
      cargoLaboral: this.integranteEnEdicion.cargoLaboral || "",
      funcion: funcionId, // Guardar el ID
      estado: Number(this.formEditarIntegrante.get("estado")?.value),
      motivo: 3,
      observaciones: "Cambio de cargo o función",
    };

    // Validación: verificar que el cargo del integrante sea permitido para la función seleccionada
    const cargoActual = this.integranteEnEdicion.cargoLaboral || "";
    /* if (!this.esCargoPermitidoParaFuncion(funcionDescripcion, cargoActual)) {
      this.cargandoGuardar = false;
      const permitidos = this.FUNCION_ALLOWED_CARGOS[(funcionDescripcion || "").toString().trim().toUpperCase()] || [];
      Swal.fire(
        "Validación",
        `La función "${funcionDescripcion}" solo permite los cargos: ${permitidos.join(", ")}`,
        "warning",
      );
      return;
    } */

      

    // Validación: función única (excluyendo el integrante actual en edición)

    if (this.isFuncionAsignada(funcionId)) {
        this.cargandoGuardar = false;
        Swal.fire({
          title: "Función no disponible",
          html: `<p>La función <strong>"${funcionDescripcion}"</strong> ya está asignada a otro integrante.</p>
               <p>Cada función debe tener un único representante en el comité.</p>`,
          icon: "error",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#0d6efd",
      });
      return;
    }

/*     if (this.esFuncionYaAsignada(funcionDescripcion, this.integranteEnEdicion.id)) {
      this.cargandoGuardar = false;
      Swal.fire({
        title: "Función no disponible",
        html: `<p>La función <strong>"${funcionDescripcion}"</strong> ya está asignada a otro integrante.</p>
               <p>Cada función debe tener un único representante en el comité.</p>`,
        icon: "error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#0d6efd",
      });
      return;
    } */

    this.comiteService
      .update(String(this.integranteEnEdicion.id), payload)
      .subscribe({
        next: () => {
          this.cargandoGuardar = false;
          Swal.fire("Éxito", "Integrante actualizado correctamente", "success");
          this.modalEditarIntegranteRef.dismiss();

          // Recargar integrantes y historial
          if (this.numeroComiteEnEdicion) {
            this.cargarIntegrantesPorNumero(this.numeroComiteEnEdicion);
            this.refrescarIntegrantesModalSiAplica(this.numeroComiteEnEdicion);
            this.cargarHistorial();
          }

          this.recargarSelects();

          // Limpiar referencias
          this.integranteEnEdicion = null;
          this.numeroComiteEnEdicion = null;
        },
        error: (err) => {
          this.cargandoGuardar = false;
          this.mostrarError(err, "Error al actualizar integrante");
        },
      });
  }

  /**
   * Contar integrantes activos de un comité
   */
  contarIntegrantesActivos(numeroComite: number): number {
    const integrantes = this.obtenerIntegrantesExpandidos(numeroComite);
    return integrantes?.filter((i) => i.estado === 1).length || 0;
  }

  /**
   * Inactivar integrante del comité
   */
  inactivarIntegrante(numeroComite: number, integrante: any): void {
    // Validar que haya más de 3 integrantes activos
    const activosCount = this.contarIntegrantesActivos(numeroComite);

    if (activosCount <= 3) {
      Swal.fire({
        icon: "warning",
        title: "No se puede inactivar",
        html: `<p>El comité debe tener al menos <strong>3 integrantes activos</strong>.</p>
               <p>Actualmente hay <strong>${activosCount} integrantes activos</strong>.</p>
               <p>Agregue más integrantes antes de inactivar a <strong>${integrante.nombre}</strong>.</p>`,
        confirmButtonText: "Entendido",
      });
      return;
    }
    this.numeroComiteInactivar = numeroComite;
    this.integranteInactivar = integrante;
    this.formInactivarIntegrante.reset();

    if (this.modalInactivarIntegrante) {
      this.modalInactivarIntegranteRef = this.modalService.open(
        this.modalInactivarIntegrante,
        {
          size: "lg",
          centered: true,
          backdrop: "static",
          keyboard: false,
        },
      );
    }
  }

  confirmarInactivarIntegrante(modalRef: any): void {
    if (!this.formInactivarIntegrante.valid) {
      this.formInactivarIntegrante.markAllAsTouched();
      Swal.fire(
        "Validación",
        "Debe diligenciar motivo y observaciones",
        "warning",
      );
      return;
    }

    if (!this.integranteInactivar || !this.numeroComiteInactivar) {
      Swal.fire(
        "Error",
        "No hay integrante seleccionado para inactivar",
        "error",
      );
      return;
    }

    this.cargandoInactivar = true;
    this.cargandoIntegrantes[this.numeroComiteInactivar] = true;

    const payload = {
      motivo: this.formInactivarIntegrante.get("motivo")?.value,
      observaciones: this.formInactivarIntegrante.get("observaciones")?.value,
    };

    this.comiteService
      .inactivar(Number(this.integranteInactivar.id), payload)
      .subscribe({
        next: () => {
          this.cargandoInactivar = false;
          this.cargandoIntegrantes[this.numeroComiteInactivar as number] =
            false;
          Swal.fire("Éxito", "Integrante inactivado", "success");

          // Refrescar lista de integrantes y el historial
          delete this.integrantesExpandidosMap[
            this.numeroComiteInactivar as number
          ];
          this.cargarIntegrantesPorNumero(this.numeroComiteInactivar as number);
          this.refrescarIntegrantesModalSiAplica(this.numeroComiteInactivar as number);
          this.cargarHistorial();
          this.recargarSelects();

          modalRef.dismiss();
          this.integranteInactivar = null;
          this.numeroComiteInactivar = null;
        },
        error: (err) => {
          this.cargandoInactivar = false;
          this.cargandoIntegrantes[this.numeroComiteInactivar as number] =
            false;
          this.mostrarError(err, "Error al inactivar integrante");
        },
      });
  }

  /**
   * Activar un integrante inactivo
   */
  activarIntegrante(numeroComite: number, integrante: any): void {
    this.integranteActivar = integrante;
    this.numeroComiteActivar = numeroComite;
    this.formActivarIntegrante.reset();

    if (this.modalActivarIntegrante) {
      this.modalActivarIntegranteRef = this.modalService.open(
        this.modalActivarIntegrante,
        {
          size: "lg",
          centered: true,
          backdrop: "static",
          keyboard: false,
        },
      );
    }
  }

  confirmarActivarIntegrante(modalRef: any): void {
    if (!this.formActivarIntegrante.valid || !this.integranteActivar) {
      this.formActivarIntegrante.markAllAsTouched();
      return;
    }

    const payload = {
      motivo: Number(this.formActivarIntegrante.get("motivo")?.value),
      observaciones: String(
        this.formActivarIntegrante.get("observaciones")?.value || "",
      ).trim(),
    };

    const numeroComite = this.numeroComiteActivar as number;
    this.cargandoActivar = true;
    this.cargandoIntegrantes[numeroComite] = true;

    this.comiteService
      .activar(Number(this.integranteActivar.id), payload)
      .subscribe({
        next: () => {
          this.cargandoActivar = false;
          this.cargandoIntegrantes[numeroComite] = false;
          Swal.fire("Éxito", "Integrante activado correctamente", "success");

          // Refrescar lista de integrantes y el historial
          delete this.integrantesExpandidosMap[numeroComite];
          this.cargarIntegrantesPorNumero(numeroComite);
          this.refrescarIntegrantesModalSiAplica(numeroComite);
          this.cargarHistorial();
          this.recargarSelects();

          modalRef.dismiss();
          this.integranteActivar = null;
          this.numeroComiteActivar = null;
        },
        error: (err) => {
          this.cargandoActivar = false;
          this.cargandoIntegrantes[numeroComite] = false;
          this.mostrarError(err, "Error al activar integrante");
        },
      });
  }

  /**
   * Abrir modal para agregar integrante
   */
  abrirModalAgregarIntegrante(numeroComite: number): void {

    
    this.numeroComiteParaAgregar = numeroComite;
    this.propietarioParaAgregar = null;
    this.personaYaAgregadaEnComite = false;
    this.buscandoPersonaParaAgregar = false;
    this.mensajeBusquedaPersonaAgregar = "";
    this.formAgregarIntegrante.reset();

    // Cargar funciones disponibles
   // this.cargarFuncionesComite();

   
   
    if (this.modalAgregarIntegrante) {
      this.modalAgregarIntegranteRef = this.modalService.open(
        this.modalAgregarIntegrante,
        {
          size: "lg",
          centered: true,
          backdrop: "static",
          keyboard: false,
        },
      );
    }

    // Limpiar selecciones por integrante para el modal
    (this.integrantesComite || []).forEach(i => {
      i.n_funcion = i.n_funcion ?? null;
      i.n_detalle = i.n_detalle ?? null;
      i.detalleDescripcion = i.detalleDescripcion ?? "";
      i._opcionesDetalle = i._opcionesDetalle ?? [];
    });
  }

  /**
   * Abrir modal con listado de actas del comité
   */
  abrirModalActas(numeroComite: number): void {
    this.numeroComiteActasModal = numeroComite;
    this.searchTextActasModal = "";
    this.pageActasModal = 1;
    this.actasModalLista = [];
    this.actasModalListaFiltrada = [];
    this.actasModalExpandido = {};
    this.cargandoActasModal = true;
   // this.cargarDocumentosComite(numeroComite);

    if (this.modalActasComite) {
      this.modalActasComiteRef = this.modalService.open(this.modalActasComite, {
        size: "xl",
        centered: true,
        backdrop: "static",
        keyboard: false,
      });
    }

   /*  if (this.actasExpandidasMap[numeroComite]) {
      this.prepararListadoActasModal(numeroComite);
      return;
    } */

 this.comiteActaService.getByNumeroComite(numeroComite).subscribe({
 next: (response: any) => {

  const actasLista = Array.isArray(response) ? response : [];

  // Lista original
  this.actasModalLista = [...actasLista];

  // Lista mostrada
  this.actasModalListaFiltrada = [...actasLista];

  // Aplicar filtro actual si existe
  this.aplicarFiltroActasModal();

  console.log(
    //📋 Se cargaron ${this.actasModalListaFiltrada.length} acta(s)`,
    this.actasModalListaFiltrada
  );
},

  error: (err) => {

    console.error("❌ Error al cargar actas:", err);

    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        err?.error?.error ||
        err?.error?.message ||
        "No se pudieron cargar las actas del comité",
    });

    this.actasModalListaFiltrada = [];
  },

  complete: () => {
    this.cargandoActasModal = false;
  },
});
  }

  private prepararListadoActasModal(actasLista: any): void {


    this.cargandoActasModal = false;
    this.actasModalExpandido = {};
    this.aplicarFiltroActasModal();
  }

  toggleIntegrantesActaModal(numeroActa: string | number): void {
    const key = String(numeroActa);
    this.actasModalExpandido[key] = !this.actasModalExpandido[key];
  }

  estaIntegrantesActaModalVisible(numeroActa: string | number): boolean {
    return !!this.actasModalExpandido[String(numeroActa)];
  }

  abrirDetalleActaModal(grupo: any): void {
    console.log(grupo);
    this.actaDetalleSeleccionada = {
      ...grupo,
      compromisosActa: this.extraerCompromisosActaGrupo(grupo),
    };

    if (this.modalDetalleActaComite) {
      this.modalDetalleActaComiteRef = this.modalService.open(this.modalDetalleActaComite, {
        size: "xl",
        centered: true,
        backdrop: "static",
        keyboard: false,
      });
    }
  }

  cerrarDetalleActaModal(): void {
    this.actaDetalleSeleccionada = null;
    if (this.modalDetalleActaComiteRef) {
      this.modalDetalleActaComiteRef.dismiss();
      this.modalDetalleActaComiteRef = null;
    }
  }

aplicarFiltroActasModal(): void {

  const query = normalize(this.searchTextActasModal?.trim());

  if (!query) {
    this.actasModalListaFiltrada = [...this.actasModalLista];
    this.pageActasModal = 1;
    return;
  }

  this.actasModalListaFiltrada = this.actasModalLista.filter((acta: any) => {

    const numeroActa = normalize(String(acta.numeroActa || ""));
    const fecha = normalize(String(acta.fecha_reunion || ""));
    const tipoActa = normalize(acta.tipoActa?.descripcion || "");
    const lugar = normalize(acta.lugar_reunion || "");
    const nombreComite = normalize(acta.nombre_comite || "");

    return (
      numeroActa.includes(query) ||
      fecha.includes(query) ||
      tipoActa.includes(query) ||
      lugar.includes(query) ||
      nombreComite.includes(query)
    );
  });

  this.pageActasModal = 1;

  console.log(
    `Filtro: ${query}`,
    this.actasModalListaFiltrada.length
  );
}

  /**
   * Búsqueda de persona con espera breve al escribir
   */
  onCedulaInputAgregar(): void {
    const cedula = String(this.formAgregarIntegrante.get("cedula")?.value || "").trim();

    this.propietarioParaAgregar = null;
    this.personaYaAgregadaEnComite = false;

    if (this.timeoutBusquedaPersonaParaAgregar) {
      clearTimeout(this.timeoutBusquedaPersonaParaAgregar);
      this.timeoutBusquedaPersonaParaAgregar = null;
    }

    if (!cedula) {
      this.buscandoPersonaParaAgregar = false;
      this.mensajeBusquedaPersonaAgregar = "";
      return;
    }

    this.buscandoPersonaParaAgregar = true;
    this.mensajeBusquedaPersonaAgregar = "";
    this.timeoutBusquedaPersonaParaAgregar = setTimeout(() => {
      this.buscarPersonaParaAgregar();
    }, 700);

        

  }

  /**
   * Buscar persona por cédula para agregar
   */
  buscarPersonaParaAgregar(): void {
    if (this.timeoutBusquedaPersonaParaAgregar) {
      clearTimeout(this.timeoutBusquedaPersonaParaAgregar);
      this.timeoutBusquedaPersonaParaAgregar = null;
    }

    const cedula = this.formAgregarIntegrante.get("cedula")?.value;

    if (!cedula) {
      this.propietarioParaAgregar = null;
      this.personaYaAgregadaEnComite = false;
      this.buscandoPersonaParaAgregar = false;
      this.mensajeBusquedaPersonaAgregar = "";
      return;
    }

    const cedulaStr = String(cedula).trim();
    this.buscandoPersonaParaAgregar = true;
    this.mensajeBusquedaPersonaAgregar = "";

    //console.log(`🔍 Buscando persona con cédula: ${cedulaStr}`);

    this.propietariosService.getCedulaPesv(cedulaStr).subscribe({
      next: (res: any) => {
        console.log(`📊 Respuesta de búsqueda completa:`, res);

        if (res?.propietario) {
          const prop = res.propietario;

          // Construir nombre completo
          const nombreCompleto = [
            prop.primernombre || "",
            prop.segundonombre || "",
            prop.papellidos || "",
            prop.seapellidos || "",
          ]
            .filter((parte) => parte.trim() !== "")
            .join(" ")
            .toUpperCase();

          // Obtener cargo
          const cargoDescripcion =
            prop.cargoData?.cargos || prop.cargo_descripcion || "";

          // Guardar con el nombre completo y cargo
          this.propietarioParaAgregar = {
            ...prop,
            nombre: nombreCompleto,
            cargo_descripcion: cargoDescripcion,
          };

          this.validarPersonaYaAgregadaEnComite(cedulaStr);

           this.listaFunciones = res.cargos[0].funcionesComite.map(f => ({
        id: f.funcion.id,
        descripcion: f.funcion.descripcion
      }));
        //console.log(this.listaFunciones);
        if(this.listaFunciones.length>0){
          this.funciones_mostrar = this.listaFunciones;
        }
        
          // Actualizar funciones disponibles según el cargo (usar descripción)
       //   this.updateFuncionesMostrar(cargoDescripcion);

          console.log("✅ Persona encontrada y procesada:", {
            nombreCompleto: nombreCompleto,
            cargo: cargoDescripcion,
            cedula: prop.cedula,
          });

          this.buscandoPersonaParaAgregar = false;
          this.mensajeBusquedaPersonaAgregar = "";
        } else {
          this.propietarioParaAgregar = null;
          this.personaYaAgregadaEnComite = false;
          this.buscandoPersonaParaAgregar = false;
          this.tipoMensajeBusquedaPersonaAgregar = "warning";
          this.mensajeBusquedaPersonaAgregar = "Persona no encontrada con esa cédula.";
        }
      },
      error: (err) => {
        this.propietarioParaAgregar = null;
        this.personaYaAgregadaEnComite = false;
        this.buscandoPersonaParaAgregar = false;
        this.tipoMensajeBusquedaPersonaAgregar = "danger";
        this.mensajeBusquedaPersonaAgregar = "No se pudo buscar la persona.";
        console.error("❌ Error al buscar persona:", err);
      },
    });
  }

  private validarPersonaYaAgregadaEnComite(cedula: string): void {
    if (!this.numeroComiteParaAgregar) {
      this.personaYaAgregadaEnComite = false;
      return;
    }

    this.numeroComiteService.getIntegrantesPorNumero(this.numeroComiteParaAgregar).subscribe({
      next: (integrantes: any[]) => {
        const lista = Array.isArray(integrantes) ? integrantes : [];
        this.personaYaAgregadaEnComite = lista.some(
          (item) => String(item?.cedula ?? "").trim() === cedula,
        );
      },
      error: () => {
        this.personaYaAgregadaEnComite = false;
      },
    });
  }

  /**
   * Guardar nuevo integrante
   */
  guardarNuevoIntegrante(modalRef: any): void {
    if (!this.formAgregarIntegrante.valid) {
      this.formAgregarIntegrante.markAllAsTouched();
      Swal.fire(
        "Validación",
        "Complete todos los campos obligatorios",
        "warning",
      );
      return;
    }

    if (!this.propietarioParaAgregar) {
      Swal.fire("Error", "Debe buscar una persona válida", "error");
      return;
    }

    if (!this.numeroComiteParaAgregar) {
      Swal.fire("Error", "No se ha seleccionado un comité", "error");
      return;
    }

    if (this.personaYaAgregadaEnComite) {
      Swal.fire(
        "Advertencia",
        "Esta persona ya fue ingresada al listado del comité.",
        "warning",
      );
      return;
    }

    // Obtener la descripción de la función seleccionada
    const funcionId = this.formAgregarIntegrante.get("funcion")?.value;
    const funcionSeleccionada = this.funciones_mostrar.find(
      (f) => f.id === funcionId,
    );
    const funcionDescripcion = funcionSeleccionada?.descripcion || "";

    console.log("funcion del empleado selecionado",funcionId);
    console.log("funcion del empleado selecionado",funcionDescripcion);
    const nuevoIntegrante: ComiteIntegrante = {
      numeroComite: this.numeroComiteParaAgregar,
      cedula: Number(this.formAgregarIntegrante.get("cedula")?.value),
      nombre: this.propietarioParaAgregar.nombre || "",
      cargoLaboral: this.propietarioParaAgregar.cargo_descripcion || "",
      funcion: funcionId,
    };

    // Validación: verificar que el cargo de la persona sea permitido para la función seleccionada
    const cargoPersona = nuevoIntegrante.cargoLaboral || "";
 /*    if (!this.esCargoPermitidoParaFuncion(funcionDescripcion, cargoPersona)) {
      this.cargandoGuardar = false;
      const permitidos = this.FUNCION_ALLOWED_CARGOS[(funcionDescripcion || "").toString().trim().toUpperCase()] || [];
      Swal.fire(
        "Validación",
        `La función "${funcionDescripcion}" solo permite los cargos: ${permitidos.join(", ")}`,
        "warning",
      );
      return;
    } */

    // Validación: función única (una función = un solo representante por comité)
    if (this.isFuncionAsignada(funcionId)) {
      this.cargandoGuardar = false;
      Swal.fire({
        title: "Función no disponible",
        html: `<p>La función <strong>"${funcionDescripcion}"</strong> ya está asignada a otro integrante.</p>
               <p>Cada función debe tener un único representante en el comité.</p>`,
        icon: "error",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#0d6efd",
      });
      return;
    }

    this.cargandoGuardar = true;

    // Proceder a guardar normalmente si no hay conflicto
    this.guardarNuevoIntegranteConfirmado(nuevoIntegrante);
  }

  /**
   * Guardar nuevo integrante (después de confirmación si aplica)
   */
  private guardarNuevoIntegranteConfirmado(nuevoIntegrante: ComiteIntegrante): void {
    this.cargandoGuardar = true;

    //console.log("💾 Datos del nuevo integrante a guardar:");
    //console.log("  - Número Comité:", nuevoIntegrante.numeroComite);
    //console.log("  - Cédula:", nuevoIntegrante.cedula);
    //console.log("  - Nombre:", nuevoIntegrante.nombre);
    //console.log("  - Cargo Laboral:", nuevoIntegrante.cargoLaboral);
    //console.log("  - Función:", nuevoIntegrante.funcion);
    //console.log("📦 Objeto completo:", nuevoIntegrante);

    this.comiteService
      .guardarIntegrantes(this.numeroComiteParaAgregar as number, [
        nuevoIntegrante,
      ])
      .subscribe({
        next: () => {
          this.cargandoGuardar = false;
          Swal.fire("Éxito", "Integrante agregado correctamente", "success");

          // Refrescar lista de integrantes y el historial
          delete this.integrantesExpandidosMap[
            this.numeroComiteParaAgregar as number
          ];
          this.cargarIntegrantesPorNumero(
            this.numeroComiteParaAgregar as number,
          );
          this.refrescarIntegrantesModalSiAplica(this.numeroComiteParaAgregar as number);
          this.cargarHistorial();

          const modalRef = this.modalAgregarIntegranteRef;
          modalRef.dismiss();
          this.propietarioParaAgregar = null;
          this.numeroComiteParaAgregar = null;
        },
        error: (err) => {
          this.cargandoGuardar = false;
          this.mostrarError(err, "Error al agregar integrante");
        },
      });
  }

  /**
   * Verificar si los integrantes de un comité están expandidos
   */
  estanExpandidos(numeroComite: number): boolean {
    return !!this.integrantesExpandidosMap[numeroComite];
  }

  /**
   * Obtener integrantes expandidos de un comité
   */
  obtenerIntegrantesExpandidos(numeroComite: number): any[] {
    return this.integrantesExpandidosMap[numeroComite] || [];
  }

  /**
   * Verificar si las actas de un comité están expandidas
   */
  estanActasExpandidas(numeroComite: number): boolean {
    return !!this.actasExpandidas[numeroComite];
  }

  /**
   * Obtener actas expandidas de un comité
   */
  obtenerActasExpandidas(numeroComite: number): any[] {
    return this.actasExpandidasMap[numeroComite] || [];
  }

  /**
   * Cargar actas por número de comité
   */
  cargarActasPorNumero(numeroComite: number): void {
    if (this.estanActasExpandidas(numeroComite)) {
      // Contraer
      this.actasExpandidas[numeroComite] = false;
      return;
    }

    // Expandir
    if (this.actasExpandidasMap[numeroComite]) {
      this.actasExpandidas[numeroComite] = true;
      return;
    }

    // Cargar actas
    this.cargandoActas[numeroComite] = true;

    this.comiteActaService.getByNumeroComite(numeroComite).subscribe({
      next: (actas: any) => {
        const actasLista = actas || [];
        this.actasExpandidasMap[numeroComite] = actasLista;
        this.actasAgrupadasMap[numeroComite] =
          this.agruparActasPorNumeroActa(actasLista);
        this.actaGrupoExpandido[numeroComite] = {};
        this.actasExpandidas[numeroComite] = true;
        this.cargandoActas[numeroComite] = false;
      },
      error: (err) => {
        console.error("Error al cargar actas:", err);
        this.cargandoActas[numeroComite] = false;
        Swal.fire("Error", "No se pudieron cargar las actas", "error");
      },
    });
  }

  /**
   * Agrupa actas por su número de acta (o número de comité como respaldo)
   */
  private agruparActasPorNumeroActa(
    actas: any[],
  ): { numeroActa: string; actas: any[]; integrantes: any[] }[] {
    const grupos: {
      [numeroActa: string]: {
        actas: any[];
        integrantesMap: { [key: string]: any };
      };
    } = {};

    const agregarIntegrante = (
      numeroActa: string,
      integrante: any,
      indice: number,
    ): void => {
      if (!integrante) {
        return;
      }

      const clave = String(numeroActa);
      if (!grupos[clave]) {
        grupos[clave] = { actas: [], integrantesMap: {} };
      }

      const cedulaKey = integrante.cedula
        ? String(integrante.cedula)
        : `sin-cedula-${indice}`;

      const normalizado = {
        cedula: integrante.cedula ?? "-",
        nombre:
          integrante.nombre ||
          integrante.nombre_completo ||
          integrante.fullName ||
          integrante.nombreCompleto ||
          "-",
        cargoLaboral: integrante.cargoLaboral || integrante.cargo || "-",
        funcion: integrante.funcion || integrante.rol || "-",
      };

      grupos[clave].integrantesMap[cedulaKey] = normalizado;
    };

    (actas || []).forEach((acta, idx) => {
      const numeroActa = acta?.numeroActa ?? acta?.numeroComite ?? "Sin número";
      const clave = String(numeroActa);
      if (!grupos[clave]) {
        grupos[clave] = { actas: [], integrantesMap: {} };
      }

      grupos[clave].actas.push(acta);

      // Integrantes declarados en el acta
      if (Array.isArray(acta?.integrantes)) {
        acta.integrantes.forEach((integrante: any, i: number) =>
          agregarIntegrante(numeroActa, integrante, i),
        );
      }

      // Fallback: usar la cédula responsable como integrante si no hay lista
      if (!acta?.integrantes || acta.integrantes.length === 0) {
        agregarIntegrante(numeroActa, acta, idx);
      }
    });

    return Object.entries(grupos).map(([numeroActa, datos]) => ({
      numeroActa,
      actas: datos.actas,
      integrantes: Object.values(datos.integrantesMap),
    }));
  }

  obtenerActasAgrupadas(
    numeroComite: number,
  ): { numeroActa: string; actas: any[]; integrantes: any[] }[] {
    return this.actasAgrupadasMap[numeroComite] || [];
  }

  toggleGrupoActa(numeroComite: number, numeroActa: string): void {
    if (!this.actaGrupoExpandido[numeroComite]) {
      this.actaGrupoExpandido[numeroComite] = {};
    }

    this.actaGrupoExpandido[numeroComite][numeroActa] =
      !this.actaGrupoExpandido[numeroComite][numeroActa];
  }

  estaGrupoActaExpandido(numeroComite: number, numeroActa: string): boolean {
    return !!this.actaGrupoExpandido[numeroComite]?.[numeroActa];
  }

  /**
   * Abrir modal para inactivar comité completo
   */
  inactivarComite(numero: number): void {
    this.numeroComiteAInactivar = numero;
    this.formInactivarIntegrante.reset();

    if (this.modalInactivarComite) {
      this.modalInactivarComiteRef = this.modalService.open(
        this.modalInactivarComite,
        {
          size: "lg",
          centered: true,
          backdrop: "static",
          keyboard: false,
        },
      );
    }
  }

  /**
   * Confirmar la inactivación del comité completo con motivo automático
   */
  confirmarInactivarComite(modalRef: any): void {
    if (!this.numeroComiteAInactivar) {
      Swal.fire("Error", "No hay comité seleccionado para inactivar", "error");
      return;
    }

    // Verificar que haya motivos disponibles
    if (!this.comiteMotivo || this.comiteMotivo.length === 0) {
      Swal.fire(
        "Error",
        "No hay motivos disponibles. Por favor recargue la página.",
        "error",
      );
      return;
    }

    this.cargandoInactivar = true;

    // Forzar motivo 11 (Comité completo) según requerimiento
    const payload = {
      motivo: 11,
      observaciones: "Comité inactivado completo",
    };

    this.numeroComiteService
      .inactivar(this.numeroComiteAInactivar, payload)
      .subscribe({
        next: () => {
          this.cargandoInactivar = false;
          Swal.fire(
            "Éxito",
            "Comité e integrantes inactivados correctamente",
            "success",
          );

          // Refrescar el historial
          this.cargarHistorial();
          this.recargarSelects();

          modalRef.dismiss();
          this.numeroComiteAInactivar = null;
        },
        error: (err) => {
          this.cargandoInactivar = false;
          this.mostrarError(err, "Error al inactivar comité");
        },
      });
  }

 agregarIntegranteDesdeComiteActivo(): void {
  const cedulaSeleccionada = this.formPesv.get('integranteSeleccionado')?.value;

  if (!cedulaSeleccionada) {
    Swal.fire("Advertencia", "Seleccione un integrante", "warning");
    return;
  }

  // Normalizar para comparación segura
  const yaExiste = this.integrantesReunion.some(
    (i) => String(i.cedula).trim() === String(cedulaSeleccionada).trim()
  );

  if (yaExiste) {
    Swal.fire("Duplicado", "Este integrante ya fue agregado a la reunión", "warning");
    return;
  }

  const persona = this.integrantesActivos.find(
    (p: any) => String(p.cedula).trim() === String(cedulaSeleccionada).trim()
  );

  if (!persona) return;

  this.integrantesReunion.push({
    cedula:         persona.cedula,
    nombre:         persona.nombre,
    cargoLaboral:   persona.cargoLaboral || '-',
    funcionDetalle: persona.funcionDetalle,
    idFuncion:      persona.funcionDetalle?.id
  });

  // Limpiar el selector
  this.formPesv.get('integranteSeleccionado')?.reset();

  Swal.fire("Éxito", `${persona.nombre} agregado correctamente`, "success");
}

 agregarTodosIntegrantesDesdeComiteActivo(): void {
  if (!this.integrantesActivos || this.integrantesActivos.length === 0) {
    Swal.fire("Advertencia", "No hay integrantes activos para agregar", "warning");
    return;
  }

  let nuevosAgregados = 0;
  let duplicados = 0;

  (this.integrantesActivos || []).forEach((persona: any) => {
    
    // Normalizar a string para evitar fallos por tipo (number vs string)
    const cedulaPersona = String(persona.cedula).trim();
    
    const yaExiste = this.integrantesReunion.some(
      (i) => String(i.cedula).trim() === cedulaPersona
    );

    if (!yaExiste) {
      this.integrantesReunion.push({
        cedula:         persona.cedula,
        nombre:         persona.nombre,
        cargoLaboral:   persona.cargoLaboral || '-',
        funcionDetalle: persona.funcionDetalle,
        idFuncion:      persona.funcionDetalle?.id
      });
      nuevosAgregados++;
    } else {
      duplicados++;
    }
  });

  if (nuevosAgregados === 0) {
    Swal.fire("Sin cambios", "Todos los integrantes ya están en la reunión", "info");
    return;
  }

  const mensaje = duplicados > 0
    ? `${nuevosAgregados} integrante(s) agregados. ${duplicados} ya estaban registrados y fueron omitidos.`
    : `${nuevosAgregados} integrante(s) agregados correctamente.`;

  Swal.fire("Éxito", mensaje, "success");
}

  agregarInvitadoAReunion(): void {
    // Abrir modal de búsqueda de invitado
    this.cedulaBuscaInvitado = "";
    this.personaBuscadaInvitado = null;
    this.errorBuscaInvitado = "";
    this.modalBuscarInvitadoRef = this.modalService.open(this.modalBuscarInvitado, {
      size: "md",
      centered: true,
      backdrop: "static",
    });
  }

  abrirModalCrearInvitado(): void {
    this.formCrearInvitado.reset();
    this.modalCrearInvitadoRef = this.modalService.open(this.modalCrearInvitado, {
      size: "lg",
      centered: true,
      backdrop: "static",
    });
  }

  cerrarModalCrearInvitado(): void {
    if (this.modalCrearInvitadoRef) {
      this.modalCrearInvitadoRef.dismiss();
    }
  }

  private buscarInvitadoPorCedula(cedula: string): void {
    this.invitadosComiteService.getAll().subscribe({
      next: (response: any) => {
        const invitados = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : [];

        const invitado = invitados.find((item: any) => String(item?.cc ?? "").trim() === String(cedula).trim());

        if (!invitado) {
          this.errorBuscaInvitado = "Persona no encontrada";
          this.personaBuscadaInvitado = null;
          return;
        }

        this.personaBuscadaInvitado = {
          ...invitado,
          nombre: String(invitado?.nombre || "").trim(),
          cedula: invitado?.cc,
        };
        this.errorBuscaInvitado = "";
      },
      error: () => {
        this.errorBuscaInvitado = "Persona no encontrada";
        this.personaBuscadaInvitado = null;
      },
    });
  }

  buscarPersonaInvitado(): void {
    if (!this.cedulaBuscaInvitado || !this.cedulaBuscaInvitado.trim()) {
      this.errorBuscaInvitado = "Ingrese una cédula";
      return;
    }

    this.cargandoBuscaInvitado = true;
    this.errorBuscaInvitado = "";
    this.personaBuscadaInvitado = null;

    this.propietariosService.getCedulaPesv(this.cedulaBuscaInvitado).subscribe({
      next: (response: any) => {
        const data = response.propietario || response;
        const nombreCompleto = [
          data.primernombre,
          data.segundonombre,
          data.papellidos,
          data.seapellidos,
        ]
          .filter(Boolean)
          .join(" ")
          .replace(/\s+/g, " ")
          .trim()
          .toUpperCase();

        this.personaBuscadaInvitado = {
          ...data,
          nombre: nombreCompleto,
        };

        this.cargandoBuscaInvitado = false;
      },
      error: (err: any) => {
        this.cargandoBuscaInvitado = false;
        this.errorBuscaInvitado = "";
        this.personaBuscadaInvitado = null;

        if (err?.status === 404 || err?.error?.message === "Propietario no encontrado") {
          this.buscarInvitadoPorCedula(this.cedulaBuscaInvitado.trim());
          return;
        }

        this.errorBuscaInvitado = this.obtenerMensajeBackend(err?.error ?? err, "Persona no encontrada");
      },
    });
  }

  confirmarAgregarInvitado(): void {
    if (!this.personaBuscadaInvitado) {
      Swal.fire("Advertencia", "Seleccione una persona", "warning");
      return;
    }

    const persona = this.personaBuscadaInvitado;

    // 🚫 evitar duplicados
    if (this.integrantesReunion.some((i) => i.cedula === persona.cedula)) {
      Swal.fire("Info", "Esta persona ya fue agregada a la reunión", "info");
      return;
    }

    // Mapear datos de la persona al formato de la tabla con función "Invitado"
    this.integrantesReunion.push({
      cedula: persona.cedula,
      nombre:
        persona.nombre ||
        `${persona.primernombre || ""} ${persona.papellidos || ""}`.trim(),
      cargoLaboral: persona.cargoLaboral || "-",
      funcionDetalle: {
    id: 7,
    descripcion: "INVITADO"
  },
        idFuncion:      7,
      //funcion: "Invitado", // Función fija para invitados
      //idFuncion: 7,
      compromisoActa: "",
      avance: 0,
      fechaCompromiso: "",
    });

    Swal.fire("Éxito", "Persona invitada agregada a la reunión", "success");

    // Cerrar modal
    this.modalBuscarInvitadoRef.close();
  }

  crearInvitadoYBuscar(): void {
    if (this.formCrearInvitado.invalid) {
      this.formCrearInvitado.markAllAsTouched();
      return;
    }

    this.cargandoCrearInvitado = true;
    const valores = this.formCrearInvitado.value;
    const primerNombre = String(valores.primer_nombre || '').trim();
    const segundoNombre = String(valores.segundo_nombre || '').trim();
    const primerApellido = String(valores.primer_apellido || '').trim();
    const segundoApellido = String(valores.segundo_apellido || '').trim();
    const payload: InvitadoComite = {
      tipo_documento: Number(valores.tipo_documento),
      cc: Number(valores.cc),
      primer_nombre: primerNombre.toUpperCase(),
      segundo_nombre: segundoNombre.toUpperCase(),
      primer_apellido: primerApellido.toUpperCase(),
      segundo_apellido: segundoApellido.toUpperCase(),
      telefono: Number(valores.telefono),
    };

    this.invitadosComiteService.create(payload).subscribe({
      next: (nuevoInvitado: any) => {
        const cc = String(nuevoInvitado?.cc ?? payload.cc).trim();
        this.cargandoCrearInvitado = false;
        this.cerrarModalCrearInvitado();

        this.cedulaBuscaInvitado = cc;
        this.personaBuscadaInvitado = {
          ...nuevoInvitado,
          cedula: nuevoInvitado?.cc ?? payload.cc,
          nombre: this.formatearNombreInvitado(nuevoInvitado || payload),
        };

        this.buscarPersonaInvitado();
        Swal.fire("Éxito", this.obtenerMensajeBackend(nuevoInvitado, "Invitado creado correctamente"), "success");
      },
      error: (err: any) => {
        this.cargandoCrearInvitado = false;
        Swal.fire("Error", this.obtenerMensajeBackend(err?.error ?? err, "No se pudo crear el invitado"), "error");
      },
    });
  }

  private formatearNombreInvitado(invitado: Partial<InvitadoComite> | any): string {
    return [
      invitado?.primer_nombre,
      invitado?.segundo_nombre,
      invitado?.primer_apellido,
      invitado?.segundo_apellido,
    ]
      .filter((valor) => !!valor && String(valor).trim())
      .map((valor) => String(valor).trim())
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  cerrarModalBuscarInvitado(): void {
    if (this.modalBuscarInvitadoRef) {
      this.modalBuscarInvitadoRef.dismiss();
    }
  }

  eliminarIntegranteReunion(index: number): void {
    if (index >= 0 && index < this.integrantesReunion.length) {
      this.integrantesReunion.splice(index, 1);
      Swal.fire("Éxito", "Integrante eliminado de la reunión", "success");
    }
  }

 guardarActaReunion(): void {

  if (!this.validarActa()) {
    return;
  }

  const numeroComite = this.obtenerNumeroComite();

  if (!numeroComite) {
    return;
  }

  const payload = this.construirPayloadActa(numeroComite);
  //console.log("payload acta construido:", payload);
  Swal.fire({
    title: "Guardar Acta de Reunión",
    text: `¿Desea guardar el acta con ${this.integrantesReunion.length} integrante(s)?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, guardar",
    cancelButtonText: "Cancelar",
  }).then((result) => {

    if (!result.isConfirmed) {
      return;
    }

    this.persistirActa(payload, numeroComite);
  });
}

editarActaReunion(): void {

  if (!this.validarActa()) {
    return;
  }

const numeroComite = this.obtenerNumeroComite();

  if (!numeroComite) {
    return;
  }

  console.log("numero de comite",numeroComite);
   const payload = this.construirPayloadActa(numeroComite);

   console.log(payload);

    Swal.fire({
    title: "Aviso",
    text: `¿Desea actualizar el acta con ${this.integrantesReunion.length} integrante(s)?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, guardar",
    cancelButtonText: "Cancelar",
  }).then((result) => {

    if (!result.isConfirmed) {
      return;
    }

    this.actualizarActa(payload,numeroComite, this.actaIdEnEdicion!);
  });
}

private validarActa(): boolean {

  if (this.integrantesReunion.length < 3) {

    Swal.fire(
      "Advertencia",
      "Debe agregar mínimo 3 integrantes a la reunión para guardar el acta.",
      "warning"
    );

    return false;
  }

  const camposRequeridos = [
    "fechaReunion",
    "horaInicio",
    "horaFinalizacion",
    "lugarReunion",
    "tipoReunion",
    //"empresa",
    "vigenciaDesde",
    "temasTratados",
  ];

  const camposInvalidos = camposRequeridos.filter(
    campo => !this.formPesv.get(campo)?.value
  );

  if (camposInvalidos.length) {

    camposRequeridos.forEach(campo => {
      this.formPesv.get(campo)?.markAsTouched();
    });

    Swal.fire(
      "Advertencia",
      "Por favor complete todos los campos requeridos.",
      "warning"
    );

    return false;
  }

  const horaInicio = this.formPesv.get("horaInicio")?.value;
  const horaFin = this.formPesv.get("horaFinalizacion")?.value;

  if (horaInicio && horaFin) {

    const inicio = new Date(`2000-01-01 ${horaInicio}`);
    const fin = new Date(`2000-01-01 ${horaFin}`);

    if (fin <= inicio) {

      Swal.fire(
        "Advertencia",
        "La hora de finalización debe ser posterior a la hora de inicio.",
        "warning"
      );

      return false;
    }
  }

  const numeroActa = this.formPesv.get("numeroActa")?.value;

  if (numeroActa && Number(numeroActa) <= 0) {

    Swal.fire(
      "Advertencia",
      "El número de acta debe ser mayor a cero.",
      "warning"
    );

    return false;
  }

  return true;
}

private obtenerNumeroComite(): number | null {

  const numeroComiteActivo =
    this.obtenerNumeroComiteActivoParaActa();

  const numeroComiteFormulario =
    Number(this.formPesv.get("numeroComite")?.value);

  const numeroComite =
    numeroComiteActivo ||
    (!Number.isNaN(numeroComiteFormulario)
      ? numeroComiteFormulario
      : null);

  if (!numeroComite) {

    Swal.fire(
      "Advertencia",
      "No se encontró un comité activo para registrar el acta.",
      "warning"
    );

    return null;
  }

  return numeroComite;
}

private construirPayloadActa(numeroComite: number): any {

  const numeroActaValue =
    this.formPesv.get("numeroActa")?.value;

  const numeroActa =
    numeroActaValue
      ? Number(numeroActaValue)
      : null;

  const datosReunion = {

    ...(numeroActa ? { numeroActa } : {}),

    numeroComite,

    fecha_reunion:
      this.formPesv.get("fechaReunion")?.value,

    hora_inicio:
      this.formPesv.get("horaInicio")?.value,

    hora_finalizacion:
      this.formPesv.get("horaFinalizacion")?.value,

    lugar_reunion:
      this.formPesv.get("lugarReunion")?.value,

    /* empresa:
      this.formPesv.get("empresa")?.value, */

    tipo_reunion:
      this.formPesv.get("tipoReunion")?.value,

    nombre_comite:
      this.formPesv.get("nombreComite")?.value,

    vigencia_desde:
      this.formPesv.get("vigenciaDesde")?.value,

    temas_tratados:
      this.formPesv.get("temasTratados")?.value,

    compromisos:
      this.integrantesReunion.length,

     
  };

  // console.log("payload acta construido:", datosReunion);
  return {
   // cedula: this.integrantesReunion[0].cedula,
    integrantes: this.integrantesReunion,
    ...datosReunion,
  };
}

private persistirActa(
  payload: any,
  numeroComite: number
): void {

  this.cargando = true;

  this.comiteActaService.create(payload).subscribe({

    next: (respuesta: any) => {
      if (respuesta.codigo !== 0) {

        this.cargando = false;
        Swal.fire(
          "Error",
          respuesta.message,
          "error"
        );
        return;
      }

      const actaCreada = respuesta.data?.acta;

      // Si no hay PDF
      if (!this.pdfFileSelected) {

        this.finalizarGuardadoExitoso(
          respuesta.message,
          respuesta.data?.totalIntegrantes || 0,
          numeroComite
        );

        return;
      }else{
      // Subir PDF
       this.subirDocumentoSoporteActa(this.pdfFileSelected,numeroComite,actaCreada.id)
         this.finalizarGuardadoExitoso(
          respuesta.message,
          respuesta.data?.totalIntegrantes || 0,
          numeroComite
        );
      }
      
     

    },

    error: (err) => {

      this.cargando = false;
      console.error(err);
      Swal.fire(
        "Error",
        err?.error?.message ||
        err?.error?.error ||
        "No se pudo guardar el acta de reunión",
        "error"
      );
    },
  });
}

private actualizarActa(
  payload: any,
  numeroComite: number,
  numeroActa: number
): void {

  this.cargando = true;

  this.comiteActaService.update(numeroActa,numeroComite,payload).subscribe({

    next: (respuesta: any) => {
     // console.log("respuesta de actualizar acta",respuesta);
      if (respuesta.codigo !== 0) {

        this.cargando = false;
        Swal.fire(
          "Error",
          respuesta.message,
          "error"
        );
        return;
      }
 
      const actaActualizada = respuesta.data;

      // Si no hay PDF
      if (!this.pdfFileSelected) {

        this.finalizarGuardadoExitoso(
          respuesta.message,
          respuesta.data?.totalIntegrantes || 0,
          numeroActa
        );

        return;
      }else{
      // Subir PDF
      // console.log("SUBIR PDF");
      // console.log("pdfFileSelected",this.pdfFileSelected);
      // console.log("numeroActa",numeroActa);
      // console.log("actaActualizada.actaId",actaActualizada.actaId);
       //pdf
       //número comite
       //número de acta
        
       this.subirDocumentoSoporteActa(this.pdfFileSelected,numeroComite,numeroActa)
         this.finalizarGuardadoExitoso(
          respuesta.message,
          respuesta.data?.totalIntegrantes || 0,
          numeroActa
        );
      }
      
     

    },

    error: (err) => {

      this.cargando = false;
      console.error(err);
      Swal.fire(
        "Error",
        err?.error?.message ||
        err?.error?.error ||
        "No se pudo guardar el acta de reunión",
        "error"
      );
    },
  });
}

private mostrarExito(
  totalGuardado: number,
  numeroComite: number,
  pdfAdjunto = false
): void {

  this.cargando = false;

  Swal.fire(
    "Éxito",
    pdfAdjunto
      ? `${totalGuardado} registro(s) guardado(s) y PDF adjuntado correctamente`
      : `${totalGuardado} registro(s) guardado(s) correctamente`,
    "success"
  );

  this.finalizarGuardado(numeroComite);
}

private finalizarGuardado(
  numeroComite: number
): void {

  this.limpiarFormularioReunion();

  this.cargarHistorial();

  if (numeroComite) {

    this.refrescarActasDeComite(
      numeroComite
    );
  }

  this.recargarSelects();
}


  private registrarCompromisosActa(
    numeroComite: number,
    actasGuardadas: any[],
    numeroActaSolicitado: number | null,
  ): void {
    const numeroActa = Number(
      actasGuardadas?.[0]?.numeroActa ?? numeroActaSolicitado ?? 0,
    );

    if (!numeroActa || !this.integrantesReunion.length) {
      console.warn(
        "No fue posible registrar los compromisos del acta por datos incompletos.",
      );
      return;
    }

    const fechaReunion = this.formPesv.get("fechaReunion")?.value;
    const requests = this.integrantesReunion.map((integrante) => {
      const payload: ComiteCompromisosActaPayload = {
        numeroComite,
        numeroActa,
        compromiso: (integrante.compromisoActa || "").toString().trim(),
        responsable: Number(integrante.cedula),
        fecha: integrante.fechaCompromiso ? integrante.fechaCompromiso : fechaReunion,
        avance: Number(integrante.avance) || 0,
        estado: 1,
      };

      return this.comiteCompromisosActaService.create(payload);
    });

    forkJoin(requests).subscribe({
      next: () => {
        console.log("✅ Compromisos del acta registrados correctamente");
      },
      error: (err) => {
        console.error("Error registrando compromisos del acta:", err);
      },
    });
  }

  private refrescarActasDeComite(numeroComite: number): void {
    this.comiteActaService.getByNumeroComite(numeroComite).subscribe({
      next: (actas: any) => {
        const actasLista = Array.isArray(actas) ? actas : [];
        this.actasExpandidasMap[numeroComite] = actasLista;
        this.actasAgrupadasMap[numeroComite] = this.agruparActasPorNumeroActa(actasLista);
        this.actaGrupoExpandido[numeroComite] = {};

        if (this.numeroComiteActasModal === numeroComite) {
          this.prepararListadoActasModal(numeroComite);
        }
      },
      error: (err) => {
        console.error("Error al refrescar actas del comité:", err);
      },
    });
  }

  limpiarFormularioReunion(): void {
    this.integrantesReunion = [];
    this.pdfFileSelected = null; // Limpiar archivo PDF
    this.formPesv.patchValue({
      integranteSeleccionado: null,
      numeroActa: "",
      fechaReunion: "",
      horaInicio: "",
      horaFinalizacion: "",
      lugarReunion: "",
      tipoReunion: null,
      empresa: this.empresaNombre || "",
      vigenciaDesde: "",
      vigenciaHasta: "",
      temasTratados: "",
      compromisoActa: "",
    });
    // Limpiar estado de validación
    Object.keys(this.formPesv.controls).forEach((key) => {
      this.formPesv.get(key)?.markAsUntouched();
    });
  }

  /**
   * Manejar selección de archivo PDF
   */
  onPdfFileSelected(event: any): void {
    const file = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    this.asignarPdfActaSeleccionado(file);
    event.target.value = "";
  }

  onDragOverPdfActa(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.add("drag-over");
  }

  onDragLeavePdfActa(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");
  }

  onDropPdfActa(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");

    const file = event.dataTransfer?.files?.[0];
    if (!file) {
      return;
    }

    this.asignarPdfActaSeleccionado(file);
    event.dataTransfer?.clearData();
  }

  removePdfActaSeleccionado(): void {
    this.pdfFileSelected = null;
  }

  private asignarPdfActaSeleccionado(file: File): void {
    const extension = file.name.split(".").pop()?.toLowerCase() || "";
    if (extension !== "pdf") {
      Swal.fire("Error", "Solo se permiten archivos PDF", "error");
      this.pdfFileSelected = null;
      return;
    }

    // Validar tamaño (máximo 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      Swal.fire("Error", "El archivo no debe superar los 10MB", "error");
      this.pdfFileSelected = null;
      return;
    }

    this.pdfFileSelected = file;
    console.log(
      "✅ Archivo PDF seleccionado:",
      file.name,
      this.formatFileSize(file.size),
    );
  }

  /**
   * Formatear tamaño de archivo
   */
  formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  }

  /**
   * Obtener el próximo número de comité disponible
   */
  private obtenerProximoNumeroComite(): void {
    this.numeroComiteService.getProximoNumero().subscribe({
      next: (res: any) => {
        // Asegurar que siempre tengamos un número válido (mínimo 1)
        let numero = res?.numero || 1;

        // Si viene 0, forzar a 1
        if (numero === 0) {
          numero = 1;
        }

        this.numeroComite = numero;
        this.formPesv.patchValue({ 
          numeroComite: this.numeroComite,
        });
        //console.log("✅ Próximo número de comité asignado:", this.numeroComite);
      },
      error: (err) => {
        console.error("❌ Error al obtener próximo número de comité:", err);
        this.numeroComite = 1;
        this.formPesv.patchValue({
          numeroComite: this.numeroComite,
        });
        //console.log("⚠️ Usando número por defecto:", this.numeroComite);
      },
    });
  }

  /**
   * Verifica si existe un comité activo (estado = 1)
   * Retorna el comité activo o undefined
   */
  existeComiteActivo(): any {
    return this.numerosComiteHistorial?.find(
      (comite: any) => comite.estado === 1,
    );
  }

  /**
   * Continuar con la designación del comité después de seleccionar el número
   */
  continueWithComite(): void {
    const numeroComite = this.formPesv.get("numeroComite")?.value;

    if (!numeroComite) {
      Swal.fire("Advertencia", "Ingrese el número del comité", "warning");
      return;
    }

    // Verificar si ya existe un comité activo
    const comiteActivo = this.existeComiteActivo();

    if (comiteActivo) {
      Swal.fire({
        icon: "error",
        title: "Comité Activo Existente",
        html: `Ya existe un comité activo: <strong>No. ${comiteActivo.numero}</strong><br>
        <small>Debe inactivarlo antes de crear uno nuevo.</small>`,
        confirmButtonText: "Aceptar",
      });
      return;
    }

    // 🔧 Inicializar funciones disponibles
    if (this.funciones_comite && this.funciones_comite.length > 0) {
      this.funciones_mostrar = [...this.funciones_comite];
    } else {
      // Intentar recargar funciones
      this.funcionComiteService.getAll().subscribe({
        next: (funciones: any) => {
          const funcionesArray = Array.isArray(funciones)
            ? funciones
            : (funciones as any)?.data || [];
          this.funciones_comite = funcionesArray;
          this.funciones_mostrar = [...funcionesArray];
        },
        error: (err) => {
          console.error("Error recargando funciones:", err);
        },
      });
    }

    // Marcar como continuado
    this.comiteContinuado = true;
    this.currentWizardStep = 2; // Avanzar al paso 2
    this.nFuncionVistaSeleccionada = null;
    this.nDetalleVistaSeleccionado = null;
    this.opcionesNDetalleVista = [];

    Swal.fire({
      icon: "success",
      title: "Comité seleccionado",
      text: `Puede proceder a agregar integrantes`,
      confirmButtonText: "Aceptar",
    });
  }

  /**
   * Reiniciar el formulario de comité
   */
  reiniciarComite(): void {
    this.comiteContinuado = false;
    this.currentWizardStep = 1; // Reiniciar al paso 1
    this.integrantesComite = [];
    this.mostrarSelectsFuncionDetalle = true;
    this.archivoDigitalComite.file = null;
    this.archivoSoporteComite = null;
    this.nFuncionVistaSeleccionada = null;
    this.nDetalleVistaSeleccionado = null;
    this.opcionesNDetalleVista = [];
    (this.integrantesComite || []).forEach(i => i._opcionesDetalle = []);
    this.formPesv.patchValue({
      cedula: "",
      funcion: "",
    });
    this.propietario = null;

    // 🔧 Restablecer funciones disponibles
    this.funciones_mostrar = [...this.funciones_comite];

    this.inicializarFechas();

  }

  avanzarAAsignarFunciones(): void {
    if (!this.integrantesComite?.length || this.integrantesComite.length < 3) {
      Swal.fire(
        "Advertencia",
        "Se requieren al menos 3 integrantes para continuar.",
        "warning",
      );
      return;
    }

    this.currentWizardStep = 3;
  }

  volverAPaso2(): void {
    this.currentWizardStep = 2;
  }



  /**
   * Formatear fecha para mostrar en acta (YYYY-MM-DD a DD de MMMM de YYYY)
   */
  private formatearFechaParaDisplay(fecha: string | Date | null | undefined): string {
    if (!fecha) return "-";
    
    try {
      const dateObj = typeof fecha === "string" ? new Date(fecha) : fecha;
      if (isNaN(dateObj.getTime())) return "-";
      
      return dateObj.toLocaleDateString("es-CO", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  }

  private descargarBlobGeneradoComite(blob: Blob, nombreArchivo: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = nombreArchivo;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  private obtenerTextoFormatoComite(formato: any): string {
    return [
      formato?.nombre,
      formato?.titulo,
      formato?.descripcion,
      formato?.tipo,
      formato?.template_name,
      formato?.nombre_archivo,
      formato?.archivo,
    ]
      .filter(Boolean)
      .join(" ");
  }

  private obtenerIdFormatoComite(formato: any): number | string | null {
    if (formato?.id !== undefined && formato?.id !== null) {
      return formato.id;
    }
    if (formato?.formato_id !== undefined && formato?.formato_id !== null) {
      return formato.formato_id;
    }
    return null;
  }

  private buscarFormatoActivoComite(tipo: "conformacion" | "reunion", formatos: any[]): any | null {
    const lista = Array.isArray(formatos) ? formatos : [];
    const tokensBase = ["comite", "seguridad vial", "pesv"];
    const tokensTipo =
      tipo === "conformacion"
        ? ["conformacion", "conformación"]
        : ["acta", "reunion", "reunión"];

    const candidatos = lista
      .map((formato: any) => {
        const texto = normalize(this.obtenerTextoFormatoComite(formato));
        const scoreBase = tokensBase.filter((token) => texto.includes(normalize(token))).length;
        const scoreTipo = tokensTipo.filter((token) => texto.includes(normalize(token))).length;
        return {
          formato,
          score: scoreBase + scoreTipo,
        };
      })
      .filter((item) => item.score >= 1)
      .sort((a, b) => b.score - a.score);

    return candidatos[0]?.formato || null;
  }

  private obtenerFuncionesGeneralesComite(): string[] {
    const lista = (this.funciones_mostrar?.length ? this.funciones_mostrar : this.funciones_comite) || [];
    return lista
      .map((funcion: FuncionComiteAttributes) => funcion?.descripcion)
      .filter((descripcion: string | undefined): descripcion is string => !!descripcion);
  }

  private construirDatosFormatoConformacionComite(
    numeroComite: number,
    lista: any[],
    fechaActual: string,
    fechaInicio?: string,
    fechaFin?: string,
    esInactivo: boolean = false,
  ): any {
    const funcionesGenerales = this.obtenerFuncionesGeneralesComite();

    return {
      tituloComite: "ACTA DE CONFORMACION DEL COMITE DE SEGURIDAD VIAL",
      nombreComite: "Comite PESV",
      fecha: fechaActual,
      fechaActual,
      fechaConformacion: fechaActual,
      numeroComite,
      vigenciaDesde: this.formatearFechaParaDisplay(fechaInicio),
      estadoComite: esInactivo ? "VENCIDO / INACTIVO" : "ACTIVO",
      comiteVencido: esInactivo ? "COMITE VENCIDO" : "",
      empresa: this.propietario?.razonsocial || this.propietario?.nombre || "",
      nit: this.empresaNit || "",
      objetivoGeneral:
        "Diseñar, implementar, realizar seguimiento y mejora al Plan Estrategico de Seguridad Vial, influenciando y promoviendo la formacion de habitos, comportamientos interdependientes y conductas seguras en la via.",
      funcionesGenerales,
      integrantes: lista.map((integrante: any, index: number) => ({
        item: index + 1,
        cedula: integrante?.cedula || "-",
        nombre: integrante?.nombre || "-",
        cargo: integrante?.cargoLaboral || integrante?.cargo || "-",
        funcion: integrante?.funcion || "-",
        estado: Number(integrante?.estado) === 1 ? "ACTIVO" : "INACTIVO",
      })),
    };
  }

  private construirDatosFormatoReunionComite(
    numeroComite: number,
    numeroActa: string | number,
    grupoActa: any,
    acta: any,
  ): any {
    return {
      tituloComite: acta?.nombre_comite || "ACTA DE REUNION COMITE PESV",
      nombreComite: acta?.nombre_comite || "Comite PESV",
      fecha: this.formatDateTodo(acta?.fecha_reunion),
      fechaReunion: this.formatDateTodo(acta?.fecha_reunion),
      numeroActa,
      numeroComite,
      empresa: acta?.empresa || "",
      horaInicio: acta?.hora_inicio || "",
      horaFinalizacion: acta?.hora_finalizacion || "",
      lugarReunion: acta?.lugar_reunion || "",
      tipoReunion: acta?.tipoReunionDescripcion || acta?.tipo_reunion || "",
      vigenciaDesde: this.formatDateTodo(acta?.vigencia_desde),
      temasTratados: acta?.temas_tratados || "",
      integrantes: (grupoActa?.integrantes || []).map((integrante: any) => ({
        cedula: integrante?.cedula || "-",
        nombre: integrante?.nombre || "-",
        funcion: integrante?.funcion || "-",
      })),
    };
  }

  private generarDocumentoFormatoComite(
    tipo: "conformacion" | "reunion",
    datos: any,
    nombreArchivo: string,
    fallback: () => void,
    previsualizar: boolean = false,
  ): void {
    const formatoFijoComiteConformacion = 2;

    this.formatosService.getAll().subscribe({
      next: (formatos: any[]) => {
        const lista = Array.isArray(formatos) ? formatos : [];
        const formatosActivos = lista.filter((formato: any) => {
          if (formato?.activo === true) return true;
          if (Number(formato?.activo) === 1) return true;
          if (Number(formato?.estado) === 1) return true;
          return false;
        });

        const fuenteBusqueda = formatosActivos.length ? formatosActivos : lista;
        const formato = this.buscarFormatoActivoComite(tipo, fuenteBusqueda);
        const formatoId =
          tipo === "conformacion"
            ? formatoFijoComiteConformacion
            : this.obtenerIdFormatoComite(formato);

        if (!formatoId) {
          fallback();
          return;
        }

        this.cargando = true;
        this.formatosService.generarDocumentoPdf(formatoId, datos).subscribe({
          next: (blob: Blob) => {
            this.cargando = false;
            if (previsualizar) {
              // Abrir vista previa en modal si se solicitó previsualización
              this.abrirVistaPreviaDocumentoComite(blob, nombreArchivo);
              Swal.fire("Éxito", "Documento generado. Se abrió la vista previa.", "success");
            } else {
              this.descargarBlobGeneradoComite(blob, nombreArchivo);
              Swal.fire("Exito", "Documento generado correctamente desde Formatos", "success");
            }
          },
          error: (err: any) => {
            this.cargando = false;
            console.warn("No se pudo generar desde Formatos. Se usara el PDF manual.", err);
            fallback();
          },
        });
      },
      error: (err: any) => {
        console.warn("No se pudieron consultar los formatos. Se usara el PDF manual.", err);
        fallback();
      },
    });
  }





  /**
   * Generar PDF del acta de reunión con plantilla profesional
   */
  generarPdfActa(numeroComite: number, numeroActa: string | number): void {
    try {
      const actasAgrupadas = this.obtenerActasAgrupadas(numeroComite);
      const grupoActa = actasAgrupadas.find(
        (g) => g.numeroActa === numeroActa.toString(),
      );

      if (!grupoActa || !grupoActa.actas?.length) {
        Swal.fire("Error", "No se encontraron datos del acta", "error");
        return;
      }

      const acta = grupoActa.actas[0];

      const datosFormato = this.construirDatosFormatoReunionComite(
        numeroComite,
        numeroActa,
        grupoActa,
        acta,
      );

      this.generarDocumentoFormatoComite(
        "reunion",
        datosFormato,
        `Acta_${numeroComite}_${numeroActa}.pdf`,
        () => this.generarPdfActaManual(numeroComite, numeroActa, grupoActa, acta),
      );
    } catch (error) {
      console.error("Error al generar PDF:", error);
      Swal.fire("Error", "No se pudo generar el PDF del acta", "error");
    }
  }

  private generarPdfActaManual(
    numeroComite: number,
    numeroActa: string | number,
    grupoActa: any,
    acta: any,
  ): void {
    try {

      // Crear documento PDF
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pageHeight = doc.internal.pageSize.getHeight();
      const pageWidth = doc.internal.pageSize.getWidth();
      const marginLeft = 15;
      const marginRight = 15;
      let yPosition = 15;

      // ============ 1. ENCABEZADO CON BORDE ============
      const headerHeight = 15;
      const rectX = marginLeft;
      const rectY = yPosition;
      const rectWidth = pageWidth - marginLeft - marginRight;

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.rect(rectX, rectY, rectWidth, headerHeight);

      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      doc.text("ACTA DE REUNIÓN COMITÉ PESV", pageWidth / 2, rectY + 10, {
        align: "center",
      });

      yPosition += headerHeight + 5;

      // ============ 2. INFORMACIÓN GENERAL (2 COLUMNAS) ============
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);

      const colWidth = (rectWidth - 5) / 2;
      const col1X = marginLeft;
      const col2X = marginLeft + colWidth + 5;

      // Columna 1
      doc.text(`Número de Acta:`, col1X, yPosition);
      doc.setFont("helvetica", "normal");
      doc.text(`${numeroActa}`, col1X, yPosition + 5);

      // Columna 2
      doc.setFont("helvetica", "bold");
      doc.text(`Número de Comité:`, col2X, yPosition);
      doc.setFont("helvetica", "normal");
      doc.text(`${numeroComite}`, col2X, yPosition + 5);

      yPosition += 12;

      // Empresa
      doc.setFont("helvetica", "bold");
      doc.text(`Empresa:`, col1X, yPosition);
      doc.setFont("helvetica", "normal");
      doc.text(`${acta.empresa || "N/A"}`, col1X, yPosition + 5);

      // Nombre del Comité
      doc.setFont("helvetica", "bold");
      doc.text(`Nombre del Comité:`, col2X, yPosition);
      doc.setFont("helvetica", "normal");
      doc.text(`${acta.nombre_comite || "Comité PESV"}`, col2X, yPosition + 5);

      yPosition += 12;

      // ============ 3. INFORMACIÓN DE LA REUNIÓN ============
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("INFORMACIÓN DE LA REUNIÓN", marginLeft, yPosition);
      yPosition += 7;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      doc.text(
        `Fecha: ${this.formatDateTodo(acta.fecha_reunion)}`,
        marginLeft,
        yPosition,
      );
      doc.text(`Hora Inicio: ${acta.hora_inicio}`, col2X, yPosition);
      yPosition += 6;

      doc.text(`Hora Fin: ${acta.hora_finalizacion}`, marginLeft, yPosition);
      yPosition += 6;

      doc.text(`Lugar: ${acta.lugar_reunion}`, marginLeft, yPosition);
      yPosition += 6;

      const tipoReunion =
        acta.tipoReunionDescripcion?.charAt(0).toUpperCase() +
        acta.tipoReunionDescripcion?.slice(1);
      doc.text(`Tipo de Reunión: ${tipoReunion}`, marginLeft, yPosition);

      yPosition += 10;

      // ============ 4. VIGENCIA ============
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("VIGENCIA", marginLeft, yPosition);
      yPosition += 6;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      doc.text(
        `Desde: ${this.formatDateTodo(acta.vigencia_desde)}`,
        marginLeft,
        yPosition,
      );

      yPosition += 10;

      // ============ 5. TEMAS TRATADOS ============
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("TEMAS TRATADOS", marginLeft, yPosition);
      yPosition += 6;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      const temasSplit = doc.splitTextToSize(
        acta.temas_tratados || "No especificado",
        rectWidth,
      );
      doc.text(temasSplit, marginLeft, yPosition);
      yPosition += temasSplit.length * 4 + 6;

      // ============ 6. TABLA DE INTEGRANTES ASISTENTES ============
      if (grupoActa.integrantes?.length > 0) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("INTEGRANTES ASISTENTES", marginLeft, yPosition);
        yPosition += 8;

        const integrantesData = grupoActa.integrantes.map((integrante: any) => [
          integrante.cedula || "-",
          integrante.nombre || "-",
          (integrante.funcion || "-").toUpperCase(),
        ]);

        autoTable(doc, {
          startY: yPosition,
          head: [["CÉDULA", "NOMBRE", "FUNCIÓN"]],
          body: integrantesData,
          theme: "grid",
          margin: { left: marginLeft, right: marginRight },
          headStyles: {
            fillColor: [0, 102, 204],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9,
            halign: "center",
          },
          bodyStyles: {
            textColor: [0, 0, 0],
            fontSize: 9,
          },
          columnStyles: {
            0: { halign: "center", cellWidth: 30 },
            1: { halign: "left" },
            2: { halign: "center" },
          },
          didDrawPage: (data: any) => {
            // Pie de página
            const pageCount = (doc as any).getNumberOfPages
              ? (doc as any).getNumberOfPages()
              : (doc as any).internal.pages.length - 1;

            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.setTextColor(100);

            doc.text(`Página 1 de 1`, pageWidth / 2, pageHeight - 10, {
              align: "center",
            });
          },
        });
      }

      // Obtener el PDF como Blob
      const pdfBlob = doc.output("blob");
      const pdfFile = new File(
        [pdfBlob],
        `Acta_${numeroComite}_${numeroActa}.pdf`,
        {
          type: "application/pdf",
        },
      );

      // Descargar PDF
      Swal.fire({
        title: "PDF Generado",
        text: "¿Desea descargar el PDF?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Descargar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          doc.save(`Acta_${numeroComite}_${numeroActa}.pdf`);
          Swal.fire("Descargado", "PDF descargado correctamente", "success");
        }
      });
    } catch (error) {
      console.error("Error al generar PDF:", error);
      Swal.fire("Error", "No se pudo generar el PDF del acta", "error");
    }
  }

  /**
   * Descargar PDF existente del servidor
   */


  private abrirBlobEnNuevaPestana(blob: Blob): void {
    const blobUrl = window.URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 5000);
  }




  private resolverUrlPdfActa(urlActaPdf: string | null | undefined): string {
    const valor = String(urlActaPdf || "")
      .trim()
      .replace(/^"+|"+$/g, "");
    if (!valor) {
      return "";
    }

    const valorNormalizado = valor.replace(/\\\//g, "/");

    if (/^https?:\/\//i.test(valorNormalizado)) {
      return valorNormalizado;
    }

    if (/^storage\.googleapis\.com\//i.test(valorNormalizado)) {
      return `https://${valorNormalizado}`;
    }

    // Cuando en BD guardan solo el object path de GCS (sin dominio), construir URL pública.
    if (/^(actas|pesv\/actas)\/comiteacta\//i.test(valorNormalizado)) {
      return `https://storage.googleapis.com/admin-digitales/${valorNormalizado.replace(/^\/+/, "")}`;
    }

    if (valorNormalizado.startsWith("/")) {
      return `${environment.apiUrl}${valorNormalizado}`;
    }

    return `${environment.apiUrl}/${valorNormalizado}`;
  }

  private extraerEntidadActa(payload: any): any {
    if (!payload || typeof payload !== "object") {
      return payload;
    }

    return payload?.data?.acta || payload?.acta || payload?.data || payload;
  }

  private obtenerUrlCrudaActaPdf(acta: any): string {
    const fuente = this.extraerEntidadActa(acta);
    if (!fuente || typeof fuente !== "object") {
      return "";
    }

    const camposUrl = [
      "url_acta_pdf",
      "urlActaPdf",
      "url",
      "url_documento",
      "urlDocumento",
      "url_pdf",
      "urlPdf",
      "pdf_url",
      "pdfUrl",
      "archivo_pdf",
      "archivoPdf",
    ];

    const visitados = new Set<any>();
    const pendientes: any[] = [fuente];

    while (pendientes.length) {
      const actual = pendientes.shift();
      if (!actual || typeof actual !== "object" || visitados.has(actual)) {
        continue;
      }

      visitados.add(actual);

      for (const campo of camposUrl) {
        const valor = actual?.[campo];
        if (typeof valor === "string" && valor.trim()) {
          return valor;
        }
      }

      if (Array.isArray(actual)) {
        actual.forEach((item) => pendientes.push(item));
      } else {
        Object.values(actual).forEach((valor) => {
          if (valor && typeof valor === "object") {
            pendientes.push(valor);
          }
        });
      }
    }

    return "";
  }

  private extraerCompromisosActaGrupo(grupo: any): any[] {
    const actas = Array.isArray(grupo?.actas) ? grupo.actas : [];
    const compromisos: any[] = [];
    const vistos = new Set<string>();

    actas.forEach((acta: any) => {
      const porResponsable = acta?.compromisosByResponsable;
      if (!porResponsable || typeof porResponsable !== "object") {
        return;
      }

      Object.values(porResponsable).forEach((lista: any) => {
        if (!Array.isArray(lista)) {
          return;
        }

        lista.forEach((compromiso: any) => {
          const clave = [
            compromiso?.id ?? "",
            compromiso?.responsable ?? "",
            compromiso?.compromiso ?? "",
            compromiso?.fecha ?? "",
          ].join("|");

          if (vistos.has(clave)) {
            return;
          }

          vistos.add(clave);
          compromisos.push(compromiso);
        });
      });
    });

    return compromisos;
  }

  obtenerActaConPdfGrupo(grupo: any): any | null {
    const actas = Array.isArray(grupo?.actas) ? grupo.actas : [];
    if (!actas.length) {
      return null;
    }

    return actas.find((a: any) => this.tienePdf(a)) || actas[0];
  }

  tienePdfGrupo(grupo: any): boolean {
    const acta = this.obtenerActaConPdfGrupo(grupo);
    return !!this.resolverUrlPdfActa(this.obtenerUrlCrudaActaPdf(acta));
  }

  /**
   * Verificar si el acta tiene PDF
   */
  tienePdf(acta: any): boolean {
    return !!this.resolverUrlPdfActa(this.obtenerUrlCrudaActaPdf(acta));
  }

  // Convierte array de strings en "1. primer, 2. segundo, ..."
private formatFuncionesDetFromArray(items: string[] | undefined | null): string | null {
  if (!items || !Array.isArray(items)) return null;
  const arr = items.map(s => String(s || "").trim()).filter(s => s.length > 0);
  if (arr.length === 0) return null;
  return arr.map((v, i) => `${i + 1}. ${v}`).join(", ");
}

// Normaliza entrada que puede venir como string o array y devuelve array
private ensureArray(input: any): string[] {
  if (input === undefined || input === null) return [];
  if (Array.isArray(input)) return input.map((s: any) => String(s || "").trim()).filter((s: string) => s.length > 0);
  // si viene como string separado por comas o punto y coma
  const s = String(input);
  const sep = s.includes(";") ? ";" : s.includes(",") ? "," : null;
  if (sep) return s.split(sep).map((x: string) => x.trim()).filter((x: string) => x.length > 0);
  return s.trim().length > 0 ? [s.trim()] : [];
}


   VerDocumentoComite(idComite: number): void {
      if (!idComite) {
        Swal.fire("Error", "No se puede visualizar sin ID", "error");
        return;
      }
  
      this.visualizarPDF(idComite);
    }

     
    visualizarPDF(idComite: number): void {
                  
        if (!idComite) {
          Swal.fire("Error", "No se puede visualizar sin ID", "error");
          return;
        }
        Swal.fire({
          title: "Confirmar visualización",
          text: "¿Deseas visualizar el documento: Acta Comité PESV?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Visualizar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (!result.isConfirmed) {
            return;
          }
    
         
          if (!this.empresaNit) {
            Swal.close();
            Swal.fire(
              "Error",
              "No se pudo obtener el NIT de la empresa para visualizar el documento.",
              "error",
            );
            return;
          }
    
          const rutaActaComite = `${this.empresaNit}/pesv/documental/acta/comite/${idComite}/${idComite}/COMITE_ACTA_documental.pdf`;
    
          this.gpcGoogle.getSignedUrlFiles(rutaActaComite).subscribe({
            next: (resp) => {
              Swal.close();
              if (!resp?.url) {
                
                Swal.fire(
                  "Error",
                  "No se pudo obtener la URL del documento del comité PESV.",
                  "error",
                );
                return;
              }
    
              this.googleStoragePreview.open(resp.url, "Acta comité PESV");
             
            },
            error: (err) => {
              
              Swal.close();
              console.error(
                "❌ Error al obtener la URL del documento del comité PESV.",
                err,
              );
              Swal.fire(
                "Error",
                "No se pudo obtener la URL del documento del comité PESV.",
                "error",
              );
            },
          });
    
    
        
    
          
        });
   }

   descargarDocumentoComite(idComite: number): void {
       if (!idComite) {
         Swal.fire("Error", "No se puede descargar sin ID", "error");
         return;
       }
   
       const id = Number(idComite);
       if (Number.isNaN(id)) {
         Swal.fire("Error", "ID de comité inválido.", "error");
         return;
       }
   
     
       Swal.fire({
         title: "Descargando...",
         text: "Por favor espera mientras se descarga el documento.",
         allowOutsideClick: false,
         allowEscapeKey: false,
         showConfirmButton: false,
         didOpen: () => {
           Swal.showLoading();
         },
       });
   
       const fileName = `ACTA_LIDER_PESV_${id}.pdf`;
        const descargarConUrl = (url: string) => {
           Swal.close();
           
           this.descargarDesdeUrlFirmada(url, fileName);
         };
     
       
   
       if (!this.empresaNit) {
         Swal.close();
         
         Swal.fire(
           "Error",
           "No se pudo obtener el NIT de la empresa para descargar el documento.",
           "error",
         );
         return;
       }
   
       const rutaComite = `${this.empresaNit}/pesv/documental/acta/comite/${id}/${id}/COMITE_ACTA_documental.pdf`;
    
       this.gpcGoogle.getSignedUrlFiles(rutaComite).subscribe({
         next: (resp) => {
           Swal.close();
           if (!resp?.url) {
            // this.descargandoLiderId = null;
             Swal.fire(
               "Error",
               "No se pudo obtener la URL firmada del documento.",
               "error",
             );
             return;
           }
   
           descargarConUrl(resp.url);
         },
         error: (err) => {
          // this.descargandoLiderId = null;
           Swal.close();
           console.error(
             "❌ Error al obtener la URL firmada del documento del líder PESV.",
             err,
           );
           Swal.fire(
             "Error",
             "No se pudo obtener la URL firmada del documento.",
             "error",
           );
         },
       });
   }

  descargarDocumentoActaComite(idComite: number,numeroActa:number): void {
       if (!idComite) {
         Swal.fire("Error", "No se puede descargar sin ID", "error");
         return;
       }
   
       const id = Number(idComite);
       if (Number.isNaN(id)) {
         Swal.fire("Error", "ID de comité inválido.", "error");
         return;
       }

        const idActa = Number(numeroActa);
       if (Number.isNaN(idActa)) {
         Swal.fire("Error", "ID de Acta inválida.", "error");
         return;
       }
   
     
       Swal.fire({
         title: "Descargando...",
         text: "Por favor espera mientras se descarga el documento.",
         allowOutsideClick: false,
         allowEscapeKey: false,
         showConfirmButton: false,
         didOpen: () => {
           Swal.showLoading();
         },
       });
   
       const fileName = `ACTA_COMITE_PESV_REUNION_${idActa}.pdf`;
        const descargarConUrl = (url: string) => {
           
           
           this.descargarDesdeUrlFirmada(url, fileName);
         };
     
       
   
       if (!this.empresaNit) {
         Swal.close();
         
         Swal.fire(
           "Error",
           "No se pudo obtener el NIT de la empresa para descargar el documento.",
           "error",
         );
         return;
       }
   
       const rutaComite = `${this.empresaNit}/pesv/documental/acta/comite/${id}/${idActa}/${idActa}/COMITE_ACTA_REUNION_documental.pdf`;
    
       this.gpcGoogle.getSignedUrlFiles(rutaComite).subscribe({
         next: (resp) => {
           Swal.close();
           if (!resp?.url) {
            // this.descargandoLiderId = null;
             Swal.fire(
               "Error",
               "No se pudo obtener la URL firmada del documento.",
               "error",
             );
             return;
           }
   
           descargarConUrl(resp.url);
           Swal.close();
         },
         error: (err) => {
          // this.descargandoLiderId = null;
           Swal.close();
           console.error(
             "❌ Error al obtener la URL firmada del documento del líder PESV.",
             err,
           );
           Swal.fire(
             "Error",
             "No se pudo obtener la URL firmada del documento.",
             "error",
           );
         },
       });
   }   
  private descargarDesdeUrlFirmada(url: string, fileName: string): void {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error al descargar archivo: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        const enlace = document.createElement("a");
        enlace.href = objectUrl;
        enlace.download = fileName;
        enlace.style.display = "none";
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
        window.URL.revokeObjectURL(objectUrl);
      })
      .catch((error) => {
        console.error("Error al descargar URL firmada:", error);
        Swal.fire("Error", "No se pudo descargar el documento.", "error");
      });
  }


  private finalizarGuardadoExitoso(
    mensaje: string,
    totalIntegrantes: number,
    numeroComite: number
  ): void {

    this.cargando = false;

    Swal.fire(
      "Éxito",
      `${mensaje} con ${totalIntegrantes} integrante(s)`,
      "success"
    );

    this.formPesv.reset();

    this.integrantesReunion = [];

    this.pdfFileSelected = null;

    this.cargarHistorial();

    this.refrescarActasDeComite(numeroComite);

    this.recargarSelects();
  }

  editarActaComite(numeroComite: number, actaId: number,integrantes:[],acta:any): void {
   this.cargando = true;
   this.modoEdicion= true; 
    console.log(actaId);
    console.log(acta);
    this.idActaEditar = actaId;
    this.integrantesReunion=integrantes;
     
    // 1. Parchear el formulario
      this.formPesv.patchValue({
        fechaReunion:     acta.fecha_reunion?.split('T')[0] ?? '',
        horaInicio:       acta.hora_inicio ?? '',
        horaFinalizacion: acta.hora_finalizacion ?? '',
        lugarReunion:     acta.lugar_reunion ?? '',
        vigenciaDesde:    acta.vigencia_desde?.split('T')[0] ?? '',
        tipoReunion:      acta.tipoActa?.id ?? null,
        temasTratados:    acta.temas_tratados ?? '',


      });
     this.tabActivo =3;
      this.cargando = false;
      this.modoEdicion = true;
      this.actaIdEnEdicion = actaId;

  this.modalService.dismissAll();

}
}


